import { CiUndo } from "react-icons/ci";
import { useCallback, useEffect, useRef, useState, useMemo } from "react";
import { useIntl, FormattedMessage } from "react-intl";
import { Badge as BadgeAntD } from "antd";
import { useSelector } from "react-redux";
import { useHistory, useParams } from "react-router";
import AnimatedMainContainer from "../../../components/AnimatedMainContainer";
import {
  Container,
  TitleContainer,
  Title,
  FieldsContainer,
  Horizontal,
  SessionContainer,
  SessionIconContainer,
  SessionTitle,
  Session,
  SessionDivider,
  ClearButtonContainer,
  PeriodCategoryContainer,
  PeriodCategoryTitle,
  PeriodCategoryFieldsContainer,
  CredentialsContainer,
  CredentialsTitle,
  CredentialsFieldsContainer,
  InformationEditionContainer,
  DocumentsContainer,
  DocumentsUploadContainer,
  DocumentUpload,
  DocumentDragAndDropContainer,
  DocumentDragAndDropText,
  ActionContainer,
  BadgeContainer,
  VIPCategoryContainer,
  DocumentOpenText,
  DocumentOpenImage,
  DocumentVisualization,
  DocumentAction,
  LabelEndContainer,
  EditMetricsButtonContainer,
  ModalSaveMetricsContainer,
  FileActionsContainer,
  TableContainer,
  WithdrawalPlaceContainer,
  WithdrawalPlaceActionsContainer,
  MessageInactivationInfo,
  InactiveLinkInfo,
  ActivateButton,
  InactiveFlowInfo,
  AreaButtonsTableEventFlow,
} from "./styles";
import * as Yup from "yup";
import getValidationErrors from "../../../utils/getValidationErrors";
import { validateSingleFieldOnBlur } from "../../../utils/formValidations";
import api from "../../../service";
import { Form } from "@unform/web";
import { Scope } from "@unform/core";
import InputWithLabel from "../../../components/InputWithLabel";
import SelectWithLabel from "../../../components/SelectWithLabel";
import InputWithHorizontalLabel from "../../../components/InputWithHorizontalLabel";
import Toggle from "../../../components/Toggle";
import Modal from "../../../components/Modal";
import {
  MdInfo,
  MdTimelapse,
  MdAssignmentInd,
  MdDescription,
  MdCloudUpload,
  MdClose,
  MdLabel,
  MdImage,
  MdOutlineModeEditOutline,
} from "react-icons/md";
import { FaShoppingBasket, FaInfinity, FaRegTrashAlt } from "react-icons/fa";
import { useToast } from "../../../hooks/toast";
import DatePickerWithLabel from "../../../components/DatePickerAntdWithLabel";
import { isBefore, parse, format, isToday, isSameDay } from "date-fns";
import Badge from "../../../components/Badge";
import ConfirmationModal from "../../../components/ConfirmationModal";
import CustomDeleteModal from "../../AdminDocuments/components/CustomDeleteModal";
import { fillTimepicker } from "../../../utils/fillTimepicker";
import { isTimeBefore, isTimeAfter } from "../../../utils/timeValidation";
import { getLogoSrcFromHtml } from "../../../utils/htmlManipulation";
import { RiVipDiamondFill } from "react-icons/ri";
import FormButton from "../../../components/FormButton";
import Dropzone from "../../../components/Dropzone";
import PDFModal from "../../../components/PDFModal";
import { base64ToBlob, downloadBlob } from "../../../utils/file";
import { useLoading } from "../../../hooks/loading";
import EventFileModal from "./EventFileModal";
import Table from "../../../components/Table";
import EventUploadFlowModal from "./EventUploadFlowModal";
import ProductsModal from "../../../components/ProductsModal";
import {
  activateLinkEventFlow,
  getAllEventsData,
  getEventUploadFlows,
  inactivateLinkEventFlow,
} from "../../../service/event.service";

const Detail = () => {
  const { token, user } = useSelector((state) => state.auth);
  const { id } = useParams();
  const [key, setKey] = useState();
  const [vipGuestMetrics, setVipGuestMetrics] = useState([]);
  const [loading, setLoading] = useState(false);

  const intervalTimes = [
    {
      label: "5m",
      value: 5,
    },
    {
      label: "10m",
      value: 10,
    },
    {
      label: "15m",
      value: 15,
    },
    {
      label: "20m",
      value: 20,
    },
    {
      label: "30m",
      value: 30,
    },
  ];

  const timeOptions5m = fillTimepicker(5);
  const [integrationOptions, setIntegrationOptions] = useState([]);
  const [savedVipGuestMetrics, setSavedVipGuestMetrics] = useState({});

  const [isMetricsModalOpen, setIsMetricsModalOpen] = useState(false);
  const [
    isGuestSystemInformationRequired,
    setIsGuestSystemInformationRequired,
  ] = useState(false);
  const [logoSrc, setLogoSrc] = useState();
  const [isBannerUnmodified, setIsBannerUnmodified] = useState(false);
  const [hasRemovedOldBanner, setHasRemovedOldBanner] = useState(false);
  const { handleLoading } = useLoading();

  const formRef = useRef(null);
  const metricsFormRef = useRef(null);
  const intl = useIntl();
  const history = useHistory();

  const { addToast } = useToast();
  const [dateModalIsOpen, setDateModalIsOpen] = useState(false);
  const [activateModalIsOpen, setActivateModalIsOpen] = useState(false);
  const [deactivateModalIsOpen, setDeactivateModalIsOpen] = useState(false);
  const [
    exhibitorsIntegrationModalIsOpen,
    setExhibitorsIntegrationModalIsOpen,
  ] = useState(false);
  const [manageGuestsEnableModalIsOpen, setManageGuestsEnableModalIsOpen] =
    useState(false);
  const [vipMetricsConfirmationModalOpen, setVipMetricsConfirmationModalOpen] =
    useState(false);
  const [removeBannerModalOpen, setRemoveBannerModalOpen] = useState(false);

  const [originalStartDate, setOriginalStartDate] = useState([]);
  const [credentialSchedulingLimitsList, setCredentialSchedulingLimitsList] =
    useState([]);

  const [deleteFileModalIsOpen, setDeleteFileModalIsOpen] = useState(false);
  const [editEventFileModalIsOpen, setEditEventFileModalIsOpen] =
    useState(false);
  const [fileIdToEventFileModal, setFileIdToEventFileModal] = useState();
  const [viewEventFileModalOpen, setViewEventFileModalOpen] = useState(false);
  const [viewEventFileLocation, setViewEventFileLocation] = useState();
  const [fileIdToDelete, setFileIdToDelete] = useState();
  const [eventFileList, setEventFileList] = useState([]);
  const [withdrawalPlaceListSize, setWithdrawalPlaceListSize] = useState(1);

  const [
    deleteEventUploadFlowModalIsOpen,
    setDeleteEventUploadFlowModalIsOpen,
  ] = useState(false);
  const [
    manageEventUploadFlowModalIsOpen,
    setManageEventUploadFlowModalIsOpen,
  ] = useState(false);
  const [
    eventUploadFlowIdToEventUploadFlowModal,
    setEventUploadFlowIdToEventUploadFlowModal,
  ] = useState();
  const [eventUploadFlowIdToDelete, setEventUploadFlowIdToDelete] = useState();
  const [eventUploadFlowNameToDelete, setEventUploadFlowNameToDelete] =
    useState();
  const [eventUploadFlowsList, setEventUploadFlowsList] = useState([]);
  const [eventId, setEventId] = useState();
  const [editEventUploadFlowId, setEditEventUploadFlowId] = useState();
  const [editEventUploadflowName, setEditEventUploadflowName] = useState();
  const [hasExecutions, setHasExecutions] = useState();
  const [waitingActivating, setWaitingActivating] = useState(false);
  const [productsModalVisible, setProductsModalVisible] = useState(false);
  const [selectedProducts, setSelectedProducts] = useState([]);

  const [data, setData] = useState({
    feira: "",
    feira_ingles: "",
    edicaoDaFeira: "",
    year: "",
    eventEditionNumber: "",
    place: "",
    pavilion: "",
    address: "",
    fair_email: "",
    video_link: "",
    swapcard_group_id: "",
    swapcard_event_id: "",
    mounting_start: "",
    mounting_end: "",
    realization_start: "",
    realization_end: "",
    unmounting_start: "",
    unmounting_end: "",
    payments_start: "",
    payments_end: "",
    payments_limit_end: "",
    withdrawalPlaceList: [
      {
        name: "",
        startDate: "",
        endDate: "",
        startTime: "",
        endTime: "",
        firstDayStartTime: "",
        firstDayEndTime: "",
        answeringTimeInterval: "",
      },
      {
        name: "",
        startDate: "",
        endDate: "",
        startTime: "",
        endTime: "",
        firstDayStartTime: "",
        firstDayEndTime: "",
        answeringTimeInterval: "",
      },
      {
        name: "",
        startDate: "",
        endDate: "",
        startTime: "",
        endTime: "",
        firstDayStartTime: "",
        firstDayEndTime: "",
        answeringTimeInterval: "",
      },
    ],
    guestSystemIntegrationType: "",
    guestSystemActive: false,
    credential_metrics_free_quota: "",
    credential_metrics_considered_area: "",
    vip_deadline: "",
    vip_guest_metrics_parameter: "",
    vip_guest_metrics_value: "",
    banner: [],
  });

  // Em edições de publicidade os períodos e as métricas de credenciais deixam de ser obrigatórios
  // (RF01/RF02 - INFORMACP-4776). A flag vem do backend e é derivada do nome da edição.
  const isAdvertisingEvent = !!data.isAdvertisingEvent;

  const requiredWhenNotAdvertising = (field) =>
    isAdvertisingEvent
      ? field
      : field.required(
          intl.formatMessage({
            id: "error.field_required",
          }),
        );

  // Mesmo opcionais, os períodos são salvos em pares (início + término), e o
  // backend recusa o par pela metade nos dois sentidos. O erro é sinalizado no
  // campo que ficou vazio.
  const hasPairCounterpart = (period, suffix) => {
    const initial_date = formRef.current.getFieldValue(`${period}_start`);
    const final_date = formRef.current.getFieldValue(`${period}_end`);

    return suffix === "start"
      ? !(final_date && !initial_date)
      : !(initial_date && !final_date);
  };

  const schema = Yup.object().shape(
    {
      feira: Yup.string(),
      feira_ingles: Yup.string(),
      edicaoDaFeira: Yup.string(),
      year: Yup.string(),
      eventEditionNumber: Yup.string(),
      place: Yup.string(),
      pavilion: Yup.string(),
      address: Yup.string(),
      fair_email: Yup.string(),
      video_link: Yup.string().url(
        intl.formatMessage({ id: "error.valid_url" }),
      ),
      ecommerce_opening_date: Yup.string().nullable(),
      ecommerce_opening_time: Yup.string()
        .nullable()
        .matches(
          /^$|^(2[0-3]|[01][0-9]):([0-5][0-9])$/g,
          intl.formatMessage({ id: "error.invalid_time_hh_mm" }),
        )
        .when("ecommerce_opening_date", {
          is: (ecommerce_opening_date) => ecommerce_opening_date,
          then: Yup.string()
            .nullable()
            .required(
              intl.formatMessage({
                id: "error.field_required",
              }),
            ),
        })
        .test(
          "is-ecommerce_opening_time-incorrect",
          intl.formatMessage({ id: "error.no_date_with_time" }),
          () => {
            const initial_date = formRef.current.getFieldValue(
              "ecommerce_opening_date",
            );
            const initial_time = formRef.current.getFieldValue(
              "ecommerce_opening_time",
            );

            if (!initial_date && initial_time) {
              return false;
            }

            return true;
          },
        ),
      ecommerce_closing_date: Yup.string()
        .nullable()
        .test(
          "is-ecommerce_closing_date-incorrect1",
          intl.formatMessage({
            id: "error.initial_date_later",
          }),
          () => {
            const initial_date = formRef.current.getFieldValue(
              "ecommerce_opening_date",
            );
            const final_date = formRef.current.getFieldValue(
              "ecommerce_closing_date",
            );

            if (initial_date && final_date) {
              return isBefore(new Date(initial_date), new Date(final_date));
            }
            return true;
          },
        )
        .when("ecommerce_opening_date", {
          is: (ecommerce_opening_date) => ecommerce_opening_date,
          then: Yup.string()
            .nullable()
            .required(
              intl.formatMessage({
                id: "error.field_required",
              }),
            ),
        })
        .test(
          "is-ecommerce_closing_date-incorrect2",
          intl.formatMessage({ id: "error.no_initial_date" }),
          () => {
            const initial_date = formRef.current.getFieldValue(
              "ecommerce_opening_date",
            );
            const final_date = formRef.current.getFieldValue(
              "ecommerce_closing_date",
            );

            if (!initial_date && final_date) {
              return false;
            }

            return true;
          },
        ),
      ecommerce_closing_time: Yup.string()
        .nullable()
        .matches(
          /^$|^(2[0-3]|[01][0-9]):([0-5][0-9])$/g,
          intl.formatMessage({ id: "error.invalid_time_hh_mm" }),
        )
        .when("ecommerce_closing_date", {
          is: (ecommerce_closing_date) => ecommerce_closing_date,
          then: Yup.string()
            .nullable()
            .required(
              intl.formatMessage({
                id: "error.field_required",
              }),
            ),
        })
        .test(
          "is-ecommerce_closing_time-incorrect",
          intl.formatMessage({ id: "error.no_date_with_time" }),
          () => {
            const final_date = formRef.current.getFieldValue(
              "ecommerce_closing_date",
            );
            const final_time = formRef.current.getFieldValue(
              "ecommerce_closing_time",
            );

            if (!final_date && final_time) {
              return false;
            }

            return true;
          },
        ),
      swapcard_group_id: Yup.string(),
      swapcard_event_id: Yup.string(),
      vip_deadline: Yup.string()
        .nullable()
        .required(
          intl.formatMessage({
            id: "error.field_required",
          }),
        ),
      vip_guest_metrics_parameter: Yup.string()
        .nullable()
        .required(
          intl.formatMessage({
            id: "error.field_required",
          }),
        ),
      vip_guest_metrics_value: Yup.string()
        .nullable()
        .matches(
          /^(^$|([0-9.]*))$/g,
          intl.formatMessage({ id: "error.need_to_be_number" }),
        )
        .required(
          intl.formatMessage({
            id: "error.field_required",
          }),
        ),
      mounting_start: requiredWhenNotAdvertising(Yup.string().nullable()).test(
        "is-mounting_start-missing",
        intl.formatMessage({ id: "error.field_required" }),
        () => hasPairCounterpart("mounting", "start"),
      ),
      mounting_end: requiredWhenNotAdvertising(Yup.string().nullable())
        .test(
          "is-mounting_end-missing",
          intl.formatMessage({ id: "error.field_required" }),
          () => hasPairCounterpart("mounting", "end"),
        )
        .test(
          "is-mounting_end-incorrect1",
          intl.formatMessage({
            id: "error.initial_date_later",
          }),
          () => {
            const initial_date =
              formRef.current.getFieldValue("mounting_start");
            const final_date = formRef.current.getFieldValue("mounting_end");

            if (initial_date && final_date) {
              return isBefore(new Date(initial_date), new Date(final_date));
            }

            return true;
          },
        )
        .test(
          "is-mounting_start-incorrect2",
          intl.formatMessage({ id: "error.no_initial_date" }),
          () => {
            const initial_date =
              formRef.current.getFieldValue("mounting_start");
            const final_date = formRef.current.getFieldValue("mounting_end");

            if (!initial_date && final_date) {
              return false;
            }

            return true;
          },
        ),
      realization_start: requiredWhenNotAdvertising(Yup.string().nullable()).test(
        "is-realization_start-missing",
        intl.formatMessage({ id: "error.field_required" }),
        () => hasPairCounterpart("realization", "start"),
      ),
      realization_end: requiredWhenNotAdvertising(Yup.string().nullable())
        .test(
          "is-realization_end-missing",
          intl.formatMessage({ id: "error.field_required" }),
          () => hasPairCounterpart("realization", "end"),
        )
        .test(
          "is-realization_end-incorrect1",
          intl.formatMessage({
            id: "error.initial_date_later",
          }),
          () => {
            const initial_date =
              formRef.current.getFieldValue("realization_start");
            const final_date = formRef.current.getFieldValue("realization_end");

            if (initial_date && final_date) {
              return isBefore(new Date(initial_date), new Date(final_date));
            }
            return true;
          },
        )
        .test(
          "is-realization_end-incorrect2",
          intl.formatMessage({ id: "error.no_initial_date" }),
          () => {
            const initial_date =
              formRef.current.getFieldValue("realization_start");
            const final_date = formRef.current.getFieldValue("realization_end");

            if (!initial_date && final_date) {
              return false;
            }

            return true;
          },
        ),
      unmounting_start: requiredWhenNotAdvertising(Yup.string().nullable()).test(
        "is-unmounting_start-missing",
        intl.formatMessage({ id: "error.field_required" }),
        () => hasPairCounterpart("unmounting", "start"),
      ),
      unmounting_end: requiredWhenNotAdvertising(Yup.string().nullable())
        .test(
          "is-unmounting_end-missing",
          intl.formatMessage({ id: "error.field_required" }),
          () => hasPairCounterpart("unmounting", "end"),
        )
        .test(
          "is-unmounting_end-incorrect1",
          intl.formatMessage({
            id: "error.initial_date_later",
          }),
          () => {
            const initial_date =
              formRef.current.getFieldValue("unmounting_start");
            const final_date = formRef.current.getFieldValue("unmounting_end");

            if (initial_date && final_date) {
              return isBefore(new Date(initial_date), new Date(final_date));
            }
            return true;
          },
        )
        .test(
          "is-unmounting_end-incorrect2",
          intl.formatMessage({ id: "error.no_initial_date" }),
          () => {
            const initial_date =
              formRef.current.getFieldValue("unmounting_start");
            const final_date = formRef.current.getFieldValue("unmounting_end");

            if (!initial_date && final_date) {
              return false;
            }

            return true;
          },
        ),
      payments_start: requiredWhenNotAdvertising(Yup.string().nullable()).test(
        "is-payments_start-missing",
        intl.formatMessage({ id: "error.field_required" }),
        () => hasPairCounterpart("payments", "start"),
      ),
      payments_end: requiredWhenNotAdvertising(Yup.string().nullable())
        .test(
          "is-payments_end-missing",
          intl.formatMessage({ id: "error.field_required" }),
          () => hasPairCounterpart("payments", "end"),
        )
        .test(
          "is-payments_end-incorrect1",
          intl.formatMessage({
            id: "error.initial_date_later",
          }),
          () => {
            const initial_date =
              formRef.current.getFieldValue("payments_start");
            const final_date = formRef.current.getFieldValue("payments_end");

            if (initial_date && final_date) {
              return isBefore(new Date(initial_date), new Date(final_date));
            }
            return true;
          },
        )
        .test(
          "is-payments_end-incorrect2",
          intl.formatMessage({ id: "error.no_initial_date" }),
          () => {
            const initial_date =
              formRef.current.getFieldValue("payments_start");
            const final_date = formRef.current.getFieldValue("payments_end");

            if (!initial_date && final_date) {
              return false;
            }

            return true;
          },
        ),
      payments_limit_end: requiredWhenNotAdvertising(Yup.string().nullable()),
      withdrawal_place: Yup.array(
        Yup.object({
          appointment_name: Yup.string()
            .nullable()
            .test(
              "is_appointment_name_active",
              intl.formatMessage({
                id: "error.field_required",
              }),
              function (item) {
                const index = parseInt(
                  this.path.split("[")[1].split("]")[0],
                  10,
                );
                if (index >= withdrawalPlaceListSize) return true;
                return !!formRef.current.getFieldValue(
                  `withdrawal_place[${index}].appointment_name`,
                );
              },
            ),
          appointment_configuration_start: Yup.string()
            .nullable()
            .test(
              "is_appointment_configuration_start_active",
              intl.formatMessage({
                id: "error.field_required",
              }),
              function (item) {
                const index = parseInt(
                  this.path.split("[")[1].split("]")[0],
                  10,
                );
                if (index >= withdrawalPlaceListSize) return true;
                return !!formRef.current.getFieldValue(
                  `withdrawal_place[${index}].appointment_configuration_start`,
                );
              },
            )
            .test(
              "is-before_current_day",
              intl.formatMessage({
                id: "error.before_current_day",
              }),
              function (item) {
                const index = parseInt(
                  this.path.split("[")[1].split("]")[0],
                  10,
                );
                if (index >= withdrawalPlaceListSize) return true;
                const initial_date = formRef.current.getFieldValue(
                  `withdrawal_place[${index}].appointment_configuration_start`,
                );

                if (isSameDay(initial_date, originalStartDate[index]))
                  return true;

                const today_date = new Date();

                if (initial_date && isToday(new Date(initial_date))) {
                  return true;
                }

                if (initial_date && today_date) {
                  return isBefore(today_date, new Date(initial_date));
                }
                return true;
              },
            ),
          appointment_configuration_end: Yup.string()
            .nullable()
            .test(
              "is_appointment_configuration_end_active",
              intl.formatMessage({
                id: "error.field_required",
              }),
              function (item) {
                const index = parseInt(
                  this.path.split("[")[1].split("]")[0],
                  10,
                );
                if (index >= withdrawalPlaceListSize) return true;
                return !!formRef.current.getFieldValue(
                  `withdrawal_place[${index}].appointment_configuration_end`,
                );
              },
            )
            .test(
              "is-payments_end-incorrect1",
              intl.formatMessage({
                id: "error.initial_date_later",
              }),
              function (item) {
                const index = parseInt(
                  this.path.split("[")[1].split("]")[0],
                  10,
                );
                if (index >= withdrawalPlaceListSize) return true;
                const initial_date = formRef.current.getFieldValue(
                  `withdrawal_place[${index}].appointment_configuration_start`,
                );
                const final_date = formRef.current.getFieldValue(
                  `withdrawal_place[${index}].appointment_configuration_end`,
                );

                if (initial_date && final_date) {
                  return isBefore(new Date(initial_date), new Date(final_date));
                }
                return true;
              },
            )
            .test(
              "is-appointment_configuration_opening-incorrect2",
              intl.formatMessage({ id: "error.no_initial_date" }),
              function (item) {
                const index = parseInt(
                  this.path.split("[")[1].split("]")[0],
                  10,
                );
                if (index >= withdrawalPlaceListSize) return true;
                const appointment_configuration_start =
                  formRef.current.getFieldValue(
                    `withdrawal_place[${index}].appointment_configuration_start`,
                  );
                const appointment_configuration_end =
                  formRef.current.getFieldValue(
                    `withdrawal_place[${index}].appointment_configuration_end`,
                  );

                if (
                  !appointment_configuration_start &&
                  appointment_configuration_end
                ) {
                  return false;
                }

                return true;
              },
            ),
          appointment_configuration_opening: Yup.string()
            .nullable()
            .test(
              "is_appointment_configuration_opening_active",
              intl.formatMessage({
                id: "error.field_required",
              }),
              function (item) {
                const index = parseInt(
                  this.path.split("[")[1].split("]")[0],
                  10,
                );
                if (index >= withdrawalPlaceListSize) return true;
                return !!formRef.current.getFieldValue(
                  `withdrawal_place[${index}].appointment_configuration_opening`,
                );
              },
            ),
          appointment_configuration_closure: Yup.string()
            .nullable()
            .test(
              "is_appointment_configuration_closure_active",
              intl.formatMessage({
                id: "error.field_required",
              }),
              function (item) {
                const index = parseInt(
                  this.path.split("[")[1].split("]")[0],
                  10,
                );
                if (index >= withdrawalPlaceListSize) return true;
                return !!formRef.current.getFieldValue(
                  `withdrawal_place[${index}].appointment_configuration_closure`,
                );
              },
            )
            .test(
              "is-appointment_configuration_closure-incorrect2",
              intl.formatMessage({ id: "error.no_initial_date" }),
              function (item) {
                const index = parseInt(
                  this.path.split("[")[1].split("]")[0],
                  10,
                );
                if (index >= withdrawalPlaceListSize) return true;
                const appointment_configuration_opening =
                  formRef.current.getFieldValue(
                    `withdrawal_place[${index}].appointment_configuration_opening`,
                  );
                const appointment_configuration_closure =
                  formRef.current.getFieldValue(
                    `withdrawal_place[${index}].appointment_configuration_closure`,
                  );

                if (
                  !appointment_configuration_opening &&
                  appointment_configuration_closure
                ) {
                  return false;
                }

                return true;
              },
            )
            .test(
              "is-payments_end-incorrect1",
              intl.formatMessage({
                id: "error.initial_date_later",
              }),
              function (item) {
                const index = parseInt(
                  this.path.split("[")[1].split("]")[0],
                  10,
                );
                if (index >= withdrawalPlaceListSize) return true;
                const appointment_configuration_opening =
                  formRef.current.getFieldValue(
                    `withdrawal_place[${index}].appointment_configuration_opening`,
                  );
                const appointment_configuration_closure =
                  formRef.current.getFieldValue(
                    `withdrawal_place[${index}].appointment_configuration_closure`,
                  );

                if (
                  appointment_configuration_opening &&
                  appointment_configuration_closure
                ) {
                  return isTimeBefore(
                    appointment_configuration_opening,
                    appointment_configuration_closure,
                  );
                }
                return true;
              },
            ),
          appointment_configuration_first_day_opening: Yup.string()
            .nullable()
            .test(
              "is_appointment_configuration_first_day_opening_active",
              intl.formatMessage({
                id: "error.field_required",
              }),
              function (item) {
                const index = parseInt(
                  this.path.split("[")[1].split("]")[0],
                  10,
                );
                if (index >= withdrawalPlaceListSize) return true;
                return !!formRef.current.getFieldValue(
                  `withdrawal_place[${index}].appointment_configuration_first_day_opening`,
                );
              },
            )
            .test(
              "is-payments_first_day_opening-incorrect1",
              intl.formatMessage({
                id: "error.first_day_date_opening",
              }),
              function (item) {
                const index = parseInt(
                  this.path.split("[")[1].split("]")[0],
                  10,
                );
                if (index >= withdrawalPlaceListSize) return true;
                const appointment_configuration_first_day_opening =
                  formRef.current.getFieldValue(
                    `withdrawal_place[${index}].appointment_configuration_first_day_opening`,
                  );
                const appointment_configuration_opening =
                  formRef.current.getFieldValue(
                    `withdrawal_place[${index}].appointment_configuration_opening`,
                  );

                if (
                  appointment_configuration_first_day_opening &&
                  appointment_configuration_opening
                ) {
                  return !isTimeAfter(
                    appointment_configuration_opening,
                    appointment_configuration_first_day_opening,
                  );
                }
                return true;
              },
            ),
          appointment_configuration_first_day_closure: Yup.string()
            .nullable()
            .test(
              "is_appointment_configuration_first_day_closure_active",
              intl.formatMessage({
                id: "error.field_required",
              }),
              function (item) {
                const index = parseInt(
                  this.path.split("[")[1].split("]")[0],
                  10,
                );
                if (index >= withdrawalPlaceListSize) return true;
                return !!formRef.current.getFieldValue(
                  `withdrawal_place[${index}].appointment_configuration_first_day_closure`,
                );
              },
            )
            .test(
              "is-appointment_configuration_first_day_closure-incorrect2",
              intl.formatMessage({ id: "error.no_initial_date" }),
              function (item) {
                const index = parseInt(
                  this.path.split("[")[1].split("]")[0],
                  10,
                );
                if (index >= withdrawalPlaceListSize) return true;
                const appointment_configuration_first_day_opening =
                  formRef.current.getFieldValue(
                    `withdrawal_place[${index}].appointment_configuration_first_day_opening`,
                  );
                const appointment_configuration_first_day_closure =
                  formRef.current.getFieldValue(
                    `withdrawal_place[${index}].appointment_configuration_first_day_closure`,
                  );

                if (
                  !appointment_configuration_first_day_opening &&
                  appointment_configuration_first_day_closure
                ) {
                  return false;
                }

                return true;
              },
            )
            .test(
              "is-payments_first_day_end-incorrect1",
              intl.formatMessage({
                id: "error.initial_date_later",
              }),
              function (item) {
                const index = parseInt(
                  this.path.split("[")[1].split("]")[0],
                  10,
                );
                if (index >= withdrawalPlaceListSize) return true;
                const appointment_configuration_first_day_opening =
                  formRef.current.getFieldValue(
                    `withdrawal_place[${index}].appointment_configuration_first_day_opening`,
                  );
                const appointment_configuration_first_day_closure =
                  formRef.current.getFieldValue(
                    `withdrawal_place[${index}].appointment_configuration_first_day_closure`,
                  );

                if (
                  appointment_configuration_first_day_opening &&
                  appointment_configuration_first_day_closure
                ) {
                  return isTimeBefore(
                    appointment_configuration_first_day_opening,
                    appointment_configuration_first_day_closure,
                  );
                }
                return true;
              },
            )
            .test(
              "is-payments_first_day_end-incorrect3",
              intl.formatMessage({
                id: "error.first_day_date_closure",
              }),
              function (item) {
                const index = parseInt(
                  this.path.split("[")[1].split("]")[0],
                  10,
                );
                if (index >= withdrawalPlaceListSize) return true;
                const appointment_configuration_closure =
                  formRef.current.getFieldValue(
                    `withdrawal_place[${index}].appointment_configuration_closure`,
                  );
                const appointment_configuration_first_day_closure =
                  formRef.current.getFieldValue(
                    `withdrawal_place[${index}].appointment_configuration_first_day_closure`,
                  );

                if (
                  appointment_configuration_closure &&
                  appointment_configuration_first_day_closure
                ) {
                  return !isTimeAfter(
                    appointment_configuration_first_day_closure,
                    appointment_configuration_closure,
                  );
                }
                return true;
              },
            ),
          interval_between_appointments: Yup.string()
            .nullable()
            .test(
              "is_interval_between_appointments_active",
              intl.formatMessage({
                id: "error.field_required",
              }),
              function (item) {
                const index = parseInt(
                  this.path.split("[")[1].split("]")[0],
                  10,
                );
                if (index >= withdrawalPlaceListSize) return true;
                return !!formRef.current.getFieldValue(
                  `withdrawal_place[${index}].interval_between_appointments`,
                );
              },
            ),
        }),
      ),
      guestSystemEventId: Yup.string()
        .test(
          "is_guest_system_active",
          intl.formatMessage({
            id: "error.field_required",
          }),
          () => {
            if (!isGuestSystemInformationRequired) return true;
            if (!formRef.current.getFieldValue("guestSystemEventId"))
              return false;
            return true;
          },
        )
        .max(
          50,
          intl.formatMessage({ id: "error.max_length" }, { length: 50 }),
        ),
      guestSystemEventEv: Yup.string()
        .test(
          "is_guest_system_active",
          intl.formatMessage({
            id: "error.field_required",
          }),
          () => {
            if (!isGuestSystemInformationRequired) return true;
            if (!formRef.current.getFieldValue("guestSystemEventEv"))
              return false;
            return true;
          },
        )
        .max(
          50,
          intl.formatMessage({ id: "error.max_length" }, { length: 50 }),
        ),
      guestSystemIntegrationType: Yup.string()
        .nullable()
        .test(
          "is_guest_system_active",
          intl.formatMessage({
            id: "error.field_required",
          }),
          () => {
            if (!isGuestSystemInformationRequired) return true;
            if (!formRef.current.getFieldValue("guestSystemIntegrationType"))
              return false;
            return true;
          },
        ),
      guestSystemActive: Yup.bool()
        .nullable()
        .required(
          intl.formatMessage({
            id: "error.field_required",
          }),
        ),
      credential_metrics_free_quota: requiredWhenNotAdvertising(
        Yup.string().matches(
          /^(^$|([0-9.]*))$/g,
          intl.formatMessage({ id: "error.need_to_be_number" }),
        ),
      ),
      credential_metrics_considered_area: requiredWhenNotAdvertising(
        Yup.string().matches(
          /^(^$|([0-9.]*))$/g,
          intl.formatMessage({ id: "error.need_to_be_number" }),
        ),
      ),
      banner: Yup.object().nullable(),
    },
    [
      ["vip_guest_metrics_parameter", "vip_guest_metrics_value"],
      ["vip_deadline", "vip_guest_metrics_value"],
      ["vip_deadline", "vip_guest_metrics_parameter"],
    ],
  );

  const metricsSchema = Yup.object().shape({
    credential_metrics_free_quota_modal: Yup.string()
      .matches(
        /^(^$|([0-9.]*))$/g,
        intl.formatMessage({ id: "error.need_to_be_number" }),
      )
      .required(
        intl.formatMessage({
          id: "error.field_required",
        }),
      ),
    credential_metrics_considered_area_modal: Yup.string()
      .matches(
        /^(^$|([0-9.]*))$/g,
        intl.formatMessage({ id: "error.need_to_be_number" }),
      )
      .required(
        intl.formatMessage({
          id: "error.field_required",
        }),
      ),
  });

  const checkContainScheduledCredential = () => {
    return credentialSchedulingLimitsList.some((limit, index) => {
      if (
        !limit.firstCredentialSchedulingDate ||
        !limit.lastCredentialSchedulingDate
      )
        return false;

      const newInitialDate = new Date(
        formatDate(
          formRef?.current?.getFieldValue(
            `withdrawal_place[${index}].appointment_configuration_start`,
          ),
          "yyyy-MM-dd",
        ) + "T00:00",
      );
      const newEndDate = new Date(
        formatDate(
          formRef?.current?.getFieldValue(
            `withdrawal_place[${index}].appointment_configuration_end`,
          ),
          "yyyy-MM-dd",
        ) + "T00:00",
      );
      const newInitialTime = formRef?.current?.getFieldValue(
        `withdrawal_place[${index}].appointment_configuration_opening`,
      );
      const newEndTime = formRef?.current?.getFieldValue(
        `withdrawal_place[${index}].appointment_configuration_closure`,
      );

      return (
        newInitialDate.getTime() >
          limit.firstCredentialSchedulingDate.getTime() ||
        newEndDate.getTime() < limit.lastCredentialSchedulingDate.getTime() ||
        newInitialTime > limit.firstCredentialSchedulingTime ||
        newEndTime < limit.lastCredentialSchedulingTime
      );
    });
  };

  const handleSubmit = useCallback(
    async (data) => {
      try {
        formRef.current?.setErrors({});

        await schema.validate(data, { abortEarly: false });

        setLoading(true);
        if (loading) {
          return;
        }

        var formData = new FormData();

        if (data.ecommerce_opening_date)
          formData.set(
            "ecommerceOpeningDate",
            formatDate(data.ecommerce_opening_date, "yyyy-MM-dd"),
          );
        formData.set("ecommerceOpeningTime", data.ecommerce_opening_time);
        if (data.ecommerce_closing_date)
          formData.set(
            "ecommerceClosingDate",
            formatDate(data.ecommerce_closing_date, "yyyy-MM-dd"),
          );
        formData.set("ecommerceClosingTime", data.ecommerce_closing_time);
        formData.set("link", data.video_link);
        formData.set("swapcardGroupId", data.swapcard_group_id);
        formData.set("swapcardEventId", data.swapcard_event_id);
        if (data.mounting_start)
          formData.set(
            "initMounting",
            formatDate(data.mounting_start, "dd/MM/yyyy"),
          );
        if (data.mounting_end)
          formData.set(
            "finishMounting",
            formatDate(data.mounting_end, "dd/MM/yyyy"),
          );
        if (data.realization_start)
          formData.set(
            "initRealization",
            formatDate(data.realization_start, "dd/MM/yyyy"),
          );
        if (data.realization_end)
          formData.set(
            "finishRealization",
            formatDate(data.realization_end, "dd/MM/yyyy"),
          );
        if (data.unmounting_start)
          formData.set(
            "initUnmounting",
            formatDate(data.unmounting_start, "dd/MM/yyyy"),
          );
        if (data.unmounting_end)
          formData.set(
            "finishUnmounting",
            formatDate(data.unmounting_end, "dd/MM/yyyy"),
          );
        if (data.payments_start)
          formData.set(
            "initPayment",
            formatDate(data.payments_start, "dd/MM/yyyy"),
          );
        if (data.payments_end)
          formData.set(
            "finishPayment",
            formatDate(data.payments_end, "dd/MM/yyyy"),
          );
        if (data.payments_limit_end)
          formData.set(
            "limitPaymentDate",
            formatDate(data.payments_limit_end, "dd/MM/yyyy"),
          );
        data.withdrawal_place.map((place, index) => {
          if (index < withdrawalPlaceListSize) {
            formData.set(
              `withdrawalPlaceList[${index}].name`,
              place.appointment_name,
            );
            formData.set(
              `withdrawalPlaceList[${index}].startDate`,
              formatDate(place.appointment_configuration_start, "yyyy-MM-dd"),
            );
            formData.set(
              `withdrawalPlaceList[${index}].endDate`,
              formatDate(place.appointment_configuration_end, "yyyy-MM-dd"),
            );
            formData.set(
              `withdrawalPlaceList[${index}].startTime`,
              place.appointment_configuration_opening,
            );
            formData.set(
              `withdrawalPlaceList[${index}].endTime`,
              place.appointment_configuration_closure,
            );
            formData.set(
              `withdrawalPlaceList[${index}].firstDayStartTime`,
              place.appointment_configuration_first_day_opening,
            );
            formData.set(
              `withdrawalPlaceList[${index}].firstDayEndTime`,
              place.appointment_configuration_first_day_closure,
            );
            formData.set(
              `withdrawalPlaceList[${index}].answeringTimeInterval`,
              place.interval_between_appointments,
            );
          }
        });
        formData.set("consideredArea", data.credential_metrics_considered_area);
        formData.set(
          "freeQuotasOnCredentials",
          data.credential_metrics_free_quota,
        );
        formData.set(
          "vipDeadline",
          formatDate(data.vip_deadline, "yyyy-MM-dd"),
        );
        formData.set(
          "vipGuestMetricsParameter",
          data.vip_guest_metrics_parameter,
        );
        formData.set("vipGuestMetricsValue", data.vip_guest_metrics_value);
        formData.set("active", data.status);
        formData.set("manageGuestsEnable", data.is_manage_guests_enable);
        formData.set(
          "integrateExhibitorsOnSwapcard",
          data.is_exhibitors_integration_enable,
        );
        formData.set("guestSystemEventId", data.guestSystemEventId);
        formData.set("guestSystemEventEv", data.guestSystemEventEv);
        formData.set(
          "guestSystemIntegrationType",
          data.guestSystemIntegrationType,
        );
        formData.set("guestSystemActive", data.guestSystemActive);
        if (data.banner && data.banner.length > 0)
          formData.set("banner", data.banner[0]);
        formData.set("hasRemovedOldBanner", hasRemovedOldBanner);

        api
          .post(`/admin/events/${id}`, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
              Accept: "*/*",
              Authorization: `Bearer ${token}`,
            },
          })
          .then((result) => {
            addToast({
              type: "success",
              title: intl.formatMessage({
                id: "success",
              }),
              description: intl.formatMessage({
                id: "success.event_updated",
              }),
            });
            history.push("/events");
          })
          .catch((err) => {
            addToast({
              type: "error",
              title: intl.formatMessage({
                id: "error",
              }),
              description: intl.formatMessage({
                id: "api.error." + err.response.data.code,
              }),
            });
          })
          .finally(() => {
            setLoading(false);
          });
      } catch (err) {
        setLoading(false);
        if (err instanceof Yup.ValidationError) {
          const errors = getValidationErrors(err);

          formRef.current?.setErrors(errors);

          return;
        }
      }
    },
    [loading, addToast, history, intl, id, schema, token, hasRemovedOldBanner],
  );

  const getAllEvents = async () => {
    try {
      const responseEventRaw = await getAllEventsData({
        token,
        data: {
          eventEditionCode: id,
          eventEditionName: "",
          active: null,
        },
      });
      const responseEvent =
        typeof responseEventRaw.json === "function"
          ? await responseEventRaw.json()
          : responseEventRaw;

      if (responseEvent?.data?.output?.length > 0) {
        setEventId(responseEvent.data.output[0].idNumber);
      } else {
        console.error("No event data found in response");
      }

      try {
        const resEventUploadFlows = await getEventUploadFlows({
          token,
          eventId: responseEvent.data.output[0].idNumber,
        });
        const flows = resEventUploadFlows.data.flows || [];
        const sortedFlows = [...flows].sort((a, b) =>
          a.uploadFlow.name.localeCompare(b.uploadFlow.name),
        );

        setEventUploadFlowsList(sortedFlows);
      } catch (err) {
        console.error("Error loading upload flows:", err);
        addToast({
          type: "error",
          title: intl.formatMessage({ id: "error" }),
          description: intl.formatMessage({
            id: "api.error." + err?.response?.data?.code,
          }),
        });
      }
    } catch (error) {
      console.error("Error in getAllEvents:", error);
    }
  };

  useEffect(() => {
    getAllEvents();
  }, []);

  useEffect(() => {
    if (integrationOptions.length === 0) return;
    handleLoading(true);
    api
      .get(`/admin/events/${id}`, {
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
          Authorization: `Bearer ${token}`,
        },
      })
      .then(async (result) => {
        const payloadPeriods = result.data.output.periods;
        const withdrawalPlaceList = result.data.output.withdrawalPlaceList;
        const fullWithdrawalPlaceList =
          generateFullWithdrawalPlaceList(withdrawalPlaceList);

        setSavedVipGuestMetrics({
          vipDeadline: result.data.output.vipDeadline,
          vipGuestMetricsParameter: result.data.output.vipGuestMetricsParameter,
          vipGuestMetricsValue: result.data.output.vipGuestMetricsValue,
        });

        setCredentialSchedulingLimitsList(
          generateFullCredentialSchedulingLimitsList(
            result.data.output.credentialSchedulingLimitsList,
          ),
        );

        setOriginalStartDate(
          fullWithdrawalPlaceList.map((place) =>
            parseStringToDate(place.startDate, "yyyy-MM-dd"),
          ),
        );

        setIsGuestSystemInformationRequired(
          result.data.output.guestSystemActive,
        );
        setWithdrawalPlaceListSize(
          withdrawalPlaceList && withdrawalPlaceList.length > 0
            ? withdrawalPlaceList.length
            : 1,
        );

        setData({
          ...result.data.output,
          ecommerce_opening_date: parseStringToDate(
            result.data.output.ecommerceOpeningDate,
            "yyyy-MM-dd",
          ),
          ecommerce_closing_date: parseStringToDate(
            result.data.output.ecommerceClosingDate,
            "yyyy-MM-dd",
          ),
          mounting_start: parseStringToDate(
            payloadPeriods?.initMounting,
            "dd/MM/yyyy",
          ),
          mounting_end: parseStringToDate(
            payloadPeriods?.finishMounting,
            "dd/MM/yyyy",
          ),
          realization_start: parseStringToDate(
            payloadPeriods?.initRealization,
            "dd/MM/yyyy",
          ),
          realization_end: parseStringToDate(
            payloadPeriods?.finishRealization,
            "dd/MM/yyyy",
          ),
          unmounting_start: parseStringToDate(
            payloadPeriods?.initUnmounting,
            "dd/MM/yyyy",
          ),
          unmounting_end: parseStringToDate(
            payloadPeriods?.finishUnmounting,
            "dd/MM/yyyy",
          ),
          payments_start: parseStringToDate(
            payloadPeriods?.initPayment,
            "dd/MM/yyyy",
          ),
          payments_end: parseStringToDate(
            payloadPeriods?.finishPayment,
            "dd/MM/yyyy",
          ),
          payments_limit_end: parseStringToDate(
            payloadPeriods?.limitPaymentDate,
            "dd/MM/yyyy",
          ),
          withdrawalPlaceList: fullWithdrawalPlaceList.map((place) => ({
            name: place.name,
            startDate: parseStringToDate(place.startDate, "yyyy-MM-dd"),
            endDate: parseStringToDate(place.endDate, "yyyy-MM-dd"),
            startTime: place.startTime,
            endTime: place.endTime,
            firstDayStartTime: place.firstDayStartTime,
            firstDayEndTime: place.firstDayEndTime,
            answeringTimeInterval: place.answeringTimeInterval,
          })),
          vip_deadline: parseStringToDate(
            result.data.output.vipDeadline,
            "yyyy-MM-dd",
          ),
        });

        setLogoSrc(getLogoSrcFromHtml(result.data.output.logo));
        if (result.data.output.banner) {
          setIsBannerUnmodified(true);
        }
        setEventFileList(result.data.output.eventFileList);

        setKey(new Date());
      })
      .catch((err) => {
        addToast({
          type: "error",
          title: intl.formatMessage({
            id: "error",
          }),
          description: intl.formatMessage({
            id: "api.error." + err.response.data.code,
          }),
        });
      })
      .finally(() => {
        handleLoading(false);
      });
    setVipGuestMetrics([
      {
        label: intl.formatMessage({ id: "quota_by_area" }),
        value: "QUOTA_AREA",
      },
      {
        label: intl.formatMessage({ id: "single_quota" }),
        value: "QUOTA_SINGLE",
      },
    ]);
  }, [addToast, intl, id, token, handleLoading, integrationOptions]);

  useEffect(() => {
    handleLoading(true);
    api
      .get(`/admin/events/integration`, {
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
          Authorization: `Bearer ${token}`,
        },
      })
      .then(async (result) => {
        setIntegrationOptions(result.data.output);
      })
      .catch((err) => {
        addToast({
          type: "error",
          title: intl.formatMessage({
            id: "error",
          }),
          description: intl.formatMessage({
            id: "api.error." + err.response.data.code,
          }),
        });
      })
      .finally(() => {
        handleLoading(false);
      });
  }, [addToast, token, intl, handleLoading]);

  const hasEditCredentialMetricsPermission = useMemo(() => {
    const dashboardCategory = user?.permissionCategories.find(
      (permission) => permission.code === "EVENTS",
    );
    if (dashboardCategory?.permissions) {
      return dashboardCategory.permissions.some(
        (infoPermission) =>
          infoPermission.code === "UPDATE_EVENT_CREDENTIAL_METRIC",
      );
    }
    return false;
  }, [user]);

  const validationBlur = (name) => {
    let errors = formRef.current.getErrors();

    validateSingleFieldOnBlur(errors, schema, name, formRef);
  };

  const validationBlurMetrics = (name) => {
    let errors = metricsFormRef.current.getErrors();

    validateSingleFieldOnBlur(errors, metricsSchema, name, metricsFormRef);
  };

  const parseStringToDate = (dateString, formatString) => {
    if (!dateString) {
      return "";
    }
    return parse(dateString, formatString, new Date());
  };

  const generateFullWithdrawalPlaceList = (withdrawalPlaceList) => {
    let splicedWithdrawalPlaceList = [
      {
        name: "",
        startDate: "",
        endDate: "",
        startTime: "",
        endTime: "",
        firstDayStartTime: "",
        firstDayEndTime: "",
        answeringTimeInterval: "",
      },
      {
        name: "",
        startDate: "",
        endDate: "",
        startTime: "",
        endTime: "",
        firstDayStartTime: "",
        firstDayEndTime: "",
        answeringTimeInterval: "",
      },
      {
        name: "",
        startDate: "",
        endDate: "",
        startTime: "",
        endTime: "",
        firstDayStartTime: "",
        firstDayEndTime: "",
        answeringTimeInterval: "",
      },
    ];

    withdrawalPlaceList.map((place, index) => {
      splicedWithdrawalPlaceList.splice(index, 1, place);
    });

    return splicedWithdrawalPlaceList;
  };

  const generateFullCredentialSchedulingLimitsList = (
    credentialSchedulingLimitsList,
  ) => {
    let splicedCredentialSchedulingLimitsList = [
      {
        firstCredentialSchedulingDate: new Date(""),
        lastCredentialSchedulingDate: new Date(""),
        firstCredentialSchedulingTime: null,
        lastCredentialSchedulingTime: null,
      },
      {
        firstCredentialSchedulingDate: new Date(""),
        lastCredentialSchedulingDate: new Date(""),
        firstCredentialSchedulingTime: null,
        lastCredentialSchedulingTime: null,
      },
      {
        firstCredentialSchedulingDate: new Date(""),
        lastCredentialSchedulingDate: new Date(""),
        firstCredentialSchedulingTime: null,
        lastCredentialSchedulingTime: null,
      },
    ];

    credentialSchedulingLimitsList.map((limits, index) => {
      splicedCredentialSchedulingLimitsList.splice(index, 1, {
        firstCredentialSchedulingDate: new Date(
          limits.firstCredentialSchedulingDate + "T" + "00:00",
        ),
        lastCredentialSchedulingDate: new Date(
          limits.lastCredentialSchedulingDate + "T" + "00:00",
        ),
        firstCredentialSchedulingTime: limits.firstCredentialSchedulingTime,
        lastCredentialSchedulingTime: limits.lastCredentialSchedulingTime,
      });
    });

    return splicedCredentialSchedulingLimitsList;
  };

  const formatDate = (date, formatString) => {
    if (!date || date === "") {
      return null;
    }

    return format(date, formatString);
  };

  const handleActivateEvent = useCallback((_) => {
    const statusValue = formRef.current.getFieldValue("status");
    if (statusValue) {
      setActivateModalIsOpen(true);
    } else {
      setDeactivateModalIsOpen(true);
    }
  }, []);

  const handleEnableManageGuests = useCallback((_) => {
    setManageGuestsEnableModalIsOpen(true);
  }, []);

  const handleExhibitorsIntegration = useCallback((_) => {
    setExhibitorsIntegrationModalIsOpen(true);
  }, []);

  const changeEventStatus = useCallback(() => {
    const statusValue = formRef.current.getFieldValue("status");

    if (statusValue) {
      setActivateModalIsOpen(false);
    } else {
      setDeactivateModalIsOpen(false);
    }

    api
      .put(
        `/admin/events/${id}`,
        { active: statusValue },
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "*/*",
            Authorization: `Bearer ${token}`,
          },
        },
      )
      .then((result) => {
        if (statusValue) {
          addToast({
            type: "success",
            title: intl.formatMessage({
              id: "success",
            }),
            description: intl.formatMessage({
              id: "success.activate_event",
            }),
          });
        } else {
          addToast({
            type: "success",
            title: intl.formatMessage({
              id: "success",
            }),
            description: intl.formatMessage({
              id: "success.deactivate_event",
            }),
          });
        }
      })
      .catch((err) => {
        addToast({
          type: "error",
          title: intl.formatMessage({
            id: "error",
          }),
          description: intl.formatMessage({
            id: "api.error." + err.response.data.code,
          }),
        });
      });
  }, [addToast, id, intl, token]);

  const changeManageGuestsStatus = useCallback(() => {
    const statusValue = formRef.current.getFieldValue(
      "is_manage_guests_enable",
    );

    setManageGuestsEnableModalIsOpen(false);

    api
      .put(
        `/admin/events/${id}/toggle-manage-guests`,
        { active: statusValue },
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "*/*",
            Authorization: `Bearer ${token}`,
          },
        },
      )
      .then((result) => {
        addToast({
          type: "success",
          title: intl.formatMessage({
            id: "success",
          }),
          description: intl.formatMessage({
            id: "success.change_manage_guests_status",
          }),
        });
      })
      .catch((err) => {
        addToast({
          type: "error",
          title: intl.formatMessage({
            id: "error",
          }),
          description: intl.formatMessage({
            id: "api.error." + err.response.data.code,
          }),
        });
      });
  }, [addToast, id, intl, token]);

  const changeExhibitorsIntegrationStatus = useCallback(() => {
    const statusValue = formRef.current.getFieldValue(
      "is_exhibitors_integration_enable",
    );

    setExhibitorsIntegrationModalIsOpen(false);

    api
      .put(
        `/admin/events/${id}/toggle-exhibitors-integration`,
        { active: statusValue },
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "*/*",
            Authorization: `Bearer ${token}`,
          },
        },
      )
      .then((result) => {
        addToast({
          type: "success",
          title: intl.formatMessage({
            id: "success",
          }),
          description: intl.formatMessage({
            id: "success.change_exhibitors_integration_status",
          }),
        });
      })
      .catch((err) => {
        addToast({
          type: "error",
          title: intl.formatMessage({
            id: "error",
          }),
          description: intl.formatMessage({
            id: "api.error." + err.response.data.code,
          }),
        });
      });
  }, [addToast, id, intl, token]);

  const cancelActivation = useCallback(() => {
    const previousValue = formRef.current.getFieldValue("status");
    formRef.current.setFieldValue("status", !previousValue);
  }, []);

  const cancelExhibitorsIntegration = useCallback(() => {
    const previousValue = formRef.current.getFieldValue(
      "is_exhibitors_integration_enable",
    );
    formRef.current.setFieldValue(
      "is_exhibitors_integration_enable",
      !previousValue,
    );
  }, []);

  const cancelManageGuestsStatusChange = useCallback(() => {
    const previousValue = formRef.current.getFieldValue(
      "is_manage_guests_enable",
    );
    formRef.current.setFieldValue("is_manage_guests_enable", !previousValue);
  }, []);

  const hasVipMetricsChanges = (
    newVipDeadline,
    newVipGuestMetricsParameter,
    newVipGuestMetricsValue,
  ) => {
    const { vipDeadline, vipGuestMetricsParameter, vipGuestMetricsValue } =
      savedVipGuestMetrics;

    if (
      !vipDeadline ||
      !vipGuestMetricsParameter ||
      vipGuestMetricsValue === null ||
      vipGuestMetricsValue === undefined
    )
      return false;

    return (
      parseStringToDate(vipDeadline, "yyyy-MM-dd").getTime() !==
        newVipDeadline.getTime() ||
      vipGuestMetricsParameter !== newVipGuestMetricsParameter ||
      vipGuestMetricsValue !== parseFloat(newVipGuestMetricsValue)
    );
  };

  const confirmVipMetricsModal = () => {
    setVipMetricsConfirmationModalOpen(false);

    if (checkContainScheduledCredential()) setDateModalIsOpen(true);
    else formRef.current.submitForm();
  };

  const confirmDateModal = () => {
    setDateModalIsOpen(false);

    formRef.current.submitForm();
  };

  const handleSubmitConditional = () => {
    const vip_deadline = formRef?.current?.getFieldValue("vip_deadline"),
      vip_guest_metrics_parameter = formRef?.current?.getFieldValue(
        "vip_guest_metrics_parameter",
      ),
      vip_guest_metrics_value = formRef?.current?.getFieldValue(
        "vip_guest_metrics_value",
      );

    if (
      hasVipMetricsChanges(
        vip_deadline,
        vip_guest_metrics_parameter,
        vip_guest_metrics_value,
      )
    ) {
      setVipMetricsConfirmationModalOpen(true);
    }

    if (checkContainScheduledCredential()) setDateModalIsOpen(true);
    else {
      formRef.current.submitForm();
    }
  };

  const handleRemoveLoadedBanner = () => {
    setRemoveBannerModalOpen(false);
    setIsBannerUnmodified(false);
    setHasRemovedOldBanner(true);
  };

  const handleExportGuests = () => {
    api
      .patch(
        `/admin/manage-guests/export`,
        {
          eventEditionCode: data.eventEditionCode,
          eventUploadFlow: true,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "*/*",
            Authorization: `Bearer ${token}`,
          },
        },
      )
      .then((result) => {
        const { file, name } = result.data.manageGuestAdminExportOutput;
        var blob = base64ToBlob(file, "application/vnd.ms-excel");
        downloadBlob(blob, `${name}.xlsx`);
      })
      .catch((err) => {
        addToast({
          type: "error",
          title: intl.formatMessage({
            id: "error",
          }),
          description: intl.formatMessage({
            id: "api.error." + err.response.data.code,
          }),
        });
      });
  };

  const clearFieldsMointing = () => {
    formRef.current.setFieldValue("mounting_start", "");
    formRef.current.setFieldValue("mounting_end", "");
  };

  const clearFieldsRelization = () => {
    formRef.current.setFieldValue("realization_start", "");
    formRef.current.setFieldValue("realization_end", "");
  };

  const clearFieldsUnmounting = () => {
    formRef.current.setFieldValue("unmounting_start", "");
    formRef.current.setFieldValue("unmounting_end", "");
  };

  const clearFieldsPayments = () => {
    formRef.current.setFieldValue("payments_start", "");
    formRef.current.setFieldValue("payments_end", "");
  };

  const clearFieldsPaymentsLimitEnd = () => {
    formRef.current.setFieldValue("payments_limit_end", "");
  };

  const incrementWithdrawalPlaceListSize = () => {
    setWithdrawalPlaceListSize(withdrawalPlaceListSize + 1);
  };

  const removeWithdrawalPlaceListItem = (index) => {
    formRef.current.setFieldValue(
      `withdrawal_place[${index}].appointment_name`,
    );
    formRef.current.setFieldValue(
      `withdrawal_place[${index}].appointment_configuration_start`,
    );
    formRef.current.setFieldValue(
      `withdrawal_place[${index}].appointment_configuration_end`,
    );
    formRef.current.setFieldValue(
      `withdrawal_place[${index}].appointment_configuration_opening`,
    );
    formRef.current.setFieldValue(
      `withdrawal_place[${index}].appointment_configuration_closure`,
    );
    formRef.current.setFieldValue(
      `withdrawal_place[${index}].appointment_configuration_first_day_opening`,
    );
    formRef.current.setFieldValue(
      `withdrawal_place[${index}].appointment_configuration_first_day_closure`,
    );
    formRef.current.setFieldValue(
      `withdrawal_place[${index}].interval_between_appointments`,
    );

    setWithdrawalPlaceListSize(withdrawalPlaceListSize - 1);
  };

  const validatePrevPath = () => {
    if (typeof history.location.state == "undefined") {
      return false;
    } else {
      if (history.location.state.prevPath.pathname.includes("/account/")) {
        return true;
      }
    }
  };

  const submitMetricsForm = useCallback(
    async (data) => {
      try {
        metricsFormRef.current?.setErrors({});

        await metricsSchema.validate(data, { abortEarly: false });

        setLoading(true);
        if (loading) {
          return;
        }

        api
          .put(
            `/admin/events/credential-metric/${id}`,
            {
              freeQuotasOnCredentials: data.credential_metrics_free_quota_modal,
              consideredArea: data.credential_metrics_considered_area_modal,
            },
            {
              headers: {
                Accept: "*/*",
                Authorization: `Bearer ${token}`,
              },
            },
          )
          .then((result) => {
            addToast({
              type: "success",
              title: intl.formatMessage({
                id: "success",
              }),
              description: intl.formatMessage({
                id: "success.event_updated",
              }),
            });
            history.push("/events");
          })
          .catch((err) => {
            addToast({
              type: "error",
              title: intl.formatMessage({
                id: "error",
              }),
              description: intl.formatMessage({
                id: "api.error." + err.response.data.code,
              }),
            });
          })
          .finally(() => {
            setLoading(false);
          });
      } catch (err) {
        setLoading(false);
        if (err instanceof Yup.ValidationError) {
          const errors = getValidationErrors(err);

          metricsFormRef.current?.setErrors(errors);

          return;
        }
      }
    },
    [loading, addToast, history, intl, id, metricsSchema, token],
  );

  const handleMetricsModalOpen = () => {
    metricsFormRef.current?.setErrors({});
    setIsMetricsModalOpen(true);
  };

  const handleGuestSystemToggleClick = () => {
    if (isGuestSystemInformationRequired) {
      formRef.current.setFieldValue("guestSystemEventId", "");
      formRef.current.setFieldValue("guestSystemEventEv", "");
      formRef.current.setFieldValue("guestSystemIntegrationType", "");
      formRef.current?.setErrors({});
    }
    setIsGuestSystemInformationRequired(!isGuestSystemInformationRequired);
  };

  const handleDeleteFileModalIsOpen = (fileId) => {
    setDeleteFileModalIsOpen(true);
    setFileIdToDelete(fileId);
  };

  const handleOpenEventFileModal = useCallback((fileId) => {
    setEditEventFileModalIsOpen(true);
    setFileIdToEventFileModal(fileId);
  }, []);

  const handleSearchForEventEditionFiles = useCallback(() => {
    try {
      setLoading(true);
      if (loading) {
        return;
      }

      api
        .get(`/event-file/by-event-edition/${id}`, {
          headers: {
            "Content-Type": "application/json",
            Accept: "*/*",
            Authorization: `Bearer ${token}`,
          },
        })
        .then((result) => {
          setEventFileList(result.data.output);
        })
        .catch((err) =>
          addToast({
            type: "error",
            title: intl.formatMessage({
              id: "error",
            }),
            description: intl.formatMessage({
              id: "api.error." + err.response.data.code,
            }),
          }),
        )
        .finally(() => setLoading(false));
    } catch (err) {
      setLoading(false);
      if (err instanceof Yup.ValidationError) {
        const errors = getValidationErrors(err);

        formRef.current?.setErrors(errors);

        return;
      }
    }
  }, [addToast, intl, token, loading, id]);

  const handleViewEventFile = useCallback(
    (id) => {
      handleLoading(true);
      api
        .get(`/event-file/${id}?action=VIEW`, {
          headers: {
            "Content-Type": "application/json",
            Accept: "*/*",
            Authorization: `Bearer ${token}`,
          },
        })
        .then((result) => {
          const readFile = result.data.output.readFile;

          if (readFile) {
            setViewEventFileLocation(result.data.output.document);
            setViewEventFileModalOpen(true);
          } else {
            window.open(result.data.output.link, "_blank");
          }
        })
        .catch((err) =>
          addToast({
            type: "error",
            title: intl.formatMessage({
              id: "error",
            }),
            description: intl.formatMessage({
              id: "api.error." + err.response.data.code,
            }),
          }),
        )
        .finally(() => handleLoading(false));
    },
    [addToast, intl, token, handleLoading],
  );

  const handleDeleteEventFile = useCallback(() => {
    setDeleteFileModalIsOpen(false);
    handleLoading(true);
    api
      .delete(`/event-file/${fileIdToDelete}`, {
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
          Authorization: `Bearer ${token}`,
        },
      })
      .then((result) => {
        addToast({
          type: "success",
          title: intl.formatMessage({
            id: "success",
          }),
          description: intl.formatMessage({
            id: "success.event_file_deleted",
          }),
        });
        handleSearchForEventEditionFiles();
      })
      .catch((err) =>
        addToast({
          type: "error",
          title: intl.formatMessage({
            id: "error",
          }),
          description: intl.formatMessage({
            id: "api.error." + err.response.data.code,
          }),
        }),
      )
      .finally(() => handleLoading(false));
  }, [
    addToast,
    intl,
    token,
    handleLoading,
    fileIdToDelete,
    handleSearchForEventEditionFiles,
  ]);

  const eventFileColumns = useMemo(
    () => [
      {
        name: intl.formatMessage({ id: "title" }),
        selector: (row) => row.title,
        sortable: true,
        allowOverflow: true,
        wrap: false,
        minWidth: "200px",
      },
      {
        name: intl.formatMessage({ id: "file_language" }),
        selector: (row) => row.fileLanguage,
        cell: (row) =>
          row.fileLanguage === "PT"
            ? intl.formatMessage({ id: "portuguese" })
            : intl.formatMessage({ id: "english" }),
      },
      {
        cell: (row) => (
          <Badge
            color="#002244"
            text={intl.formatMessage({ id: "visualize" })}
            onClick={() => handleViewEventFile(row.id)}
          />
        ),
        right: true,
        width: "150px",
      },
      {
        cell: (row) => (
          <Badge
            color="#002244"
            text={intl.formatMessage({ id: "edit" })}
            onClick={() => handleOpenEventFileModal(row.id)}
          />
        ),
        right: true,
        width: "150px",
      },
      {
        cell: (row) => (
          <Badge
            color="#002244"
            text={intl.formatMessage({ id: "delete" })}
            onClick={() => handleDeleteFileModalIsOpen(row.id)}
          />
        ),
        right: true,
        width: "150px",
      },
    ],
    [intl, handleViewEventFile, handleOpenEventFileModal],
  );

  const handleDeleteEventUploadFlowModalIsOpen = useCallback(
    (flowId, flowName, executions) => {
      if (!flowId) return;

      setEventUploadFlowIdToDelete(flowId);
      setEventUploadFlowNameToDelete(flowName);
      setHasExecutions(executions);
      setDeleteEventUploadFlowModalIsOpen(true);
    },
    [],
  );

  const handleOpenEventUploadFlowModal = (flowId) => {
    setManageEventUploadFlowModalIsOpen(true);
    setEventUploadFlowIdToEventUploadFlowModal(flowId);
  };

  const handleSearchForEventUploadFlows = useCallback(async () => {
    setLoading(true);

    try {
      const resEventUploadFlows = await getEventUploadFlows({
        token,
        eventId,
      });
      const flows = resEventUploadFlows.data.flows || [];
      const sortedFlows = [...flows].sort((a, b) =>
        a.uploadFlow.name.localeCompare(b.uploadFlow.name),
      );

      setEventUploadFlowsList(sortedFlows);
    } catch (err) {
      addToast({
        type: "error",
        title: intl.formatMessage({ id: "error" }),
        description: intl.formatMessage({
          id: "api.error." + err?.response?.data?.code,
        }),
      });
    } finally {
      setLoading(false);
    }
  }, [addToast, intl, token, eventId]);

  const handleDeleteEventUploadFlow = useCallback(async () => {
    handleLoading(true);
    setDeleteEventUploadFlowModalIsOpen(false);

    if (hasExecutions) {
      // inactivate
      try {
        const responseInactivate = await inactivateLinkEventFlow({
          eventId,
          uploadFlowId: eventUploadFlowIdToDelete,
        });

        switch (true) {
          case responseInactivate.status === 200 &&
            responseInactivate.data.code === 49002:
            const resEventUploadFlows = await getEventUploadFlows({
              token,
              eventId,
            });

            const flows = resEventUploadFlows.data.flows || [];
            const sortedFlows = [...flows].sort((a, b) =>
              a.uploadFlow.name.localeCompare(b.uploadFlow.name),
            );

            setEventUploadFlowsList(sortedFlows);

            addToast({
              type: "success",
              title: intl.formatMessage({
                id: "success",
              }),
              description: intl.formatMessage({
                id: "success.event_upload_flow_inactivate",
              }),
            });
            break;

          default:
            addToast({
              type: "error",
              title: intl.formatMessage({
                id: "error",
              }),
              description: intl.formatMessage({
                id: "error.event_upload_flow_inactivate",
              }),
            });
            break;
        }
      } catch (err) {
        addToast({
          type: "error",
          title: intl.formatMessage({
            id: "error",
          }),
          description: intl.formatMessage({
            id: "error.event_upload_flow_inactivate",
          }),
        });
      } finally {
        handleLoading(false);
      }
    } else {
      // delete
      api
        .delete(`/upload-flow/${eventUploadFlowIdToDelete}/events/${id}`, {
          headers: {
            "Content-Type": "application/json",
            Accept: "*/*",
            Authorization: `Bearer ${token}`,
          },
        })
        .then((result) => {
          addToast({
            type: "success",
            title: intl.formatMessage({
              id: "success",
            }),
            description: intl.formatMessage({
              id: "success.event_upload_flow_deleted",
            }),
          });

          handleSearchForEventUploadFlows();
        })
        .catch((err) =>
          addToast({
            type: "error",
            title: intl.formatMessage({
              id: "error",
            }),
            description: intl.formatMessage({
              id: "error.event_upload_flow_inactivate",
            }),
          }),
        )
        .finally(() => {
          handleLoading(false);
        });
    }
  }, [
    addToast,
    intl,
    token,
    handleLoading,
    eventUploadFlowIdToDelete,
    eventId,
    handleSearchForEventUploadFlows,
    hasExecutions,
    id,
  ]);

  const handleActivateEventUploadFlow = useCallback(
    async (uploadFlowId) => {
      if (!eventId) {
        addToast({
          type: "error",
          title: intl.formatMessage({ id: "error" }),
          description: "Event ID not available. Please refresh the page.",
        });
        return;
      }

      try {
        handleLoading(true);
        setWaitingActivating(true);

        const responseActivate = await activateLinkEventFlow({
          token,
          eventId,
          uploadFlowId,
        });

        switch (true) {
          case responseActivate.status === 200 &&
            responseActivate.data.code === 49002:
            const resEventUploadFlows = await getEventUploadFlows({
              token,
              eventId,
            });

            const flows = resEventUploadFlows.data.flows || [];
            const sortedFlows = [...flows].sort((a, b) =>
              a.uploadFlow.name.localeCompare(b.uploadFlow.name),
            );
            setEventUploadFlowsList(sortedFlows);

            addToast({
              type: "success",
              title: intl.formatMessage({
                id: "success",
              }),
              description: intl.formatMessage({
                id: "success.event_upload_flow_activate",
              }),
            });
            break;

          default:
            addToast({
              type: "error",
              title: intl.formatMessage({
                id: "error",
              }),
              description: intl.formatMessage({
                id: "error.event_upload_flow_activate",
              }),
            });
            break;
        }
      } catch (err) {
        addToast({
          type: "error",
          title: intl.formatMessage({
            id: "error",
          }),
          description: intl.formatMessage({
            id: "error.event_upload_flow_activate",
          }),
        });
      } finally {
        handleLoading(false);
        setWaitingActivating(false);
      }
    },
    [addToast, intl, token, eventId, handleLoading],
  );

  const eventUploadFlowsColumns = useMemo(
    () => [
      {
        name: intl.formatMessage({ id: "flow" }),
        cell: (row) => (
          <div>
            {!row.uploadFlow.active ? (
              <BadgeAntD
                count={
                  <InactiveFlowInfo>
                    {intl.formatMessage({ id: "event.link-flow-status" })}
                  </InactiveFlowInfo>
                }
                color="#666666"
                offset={[33, 0]}
              >
                <span>{row.uploadFlow.name}</span>
              </BadgeAntD>
            ) : (
              <span>{row.uploadFlow.name}</span>
            )}
          </div>
        ),
        sortable: true,
        allowOverflow: true,
        wrap: false,
        minWidth: "300px",
      },
      {
        cell: (row) => (
          <>
            {row.active ? (
              <AreaButtonsTableEventFlow>
                <Badge
                  bold={true}
                  textColor="rgba(0, 34, 68, 1)"
                  icon={MdOutlineModeEditOutline}
                  color="rgba(226, 232, 240, 1)"
                  text={intl.formatMessage({ id: "edit" })}
                  onClick={() =>
                    editingEventUploadFlow(
                      row.uploadFlow.id,
                      row.uploadFlow.name,
                    )
                  }
                />

                <Badge
                  bold={true}
                  textColor="rgba(153, 27, 27, 1)"
                  icon={FaRegTrashAlt}
                  color="rgba(254, 202, 202, 1)"
                  text={intl.formatMessage({ id: "remove" })}
                  onClick={() =>
                    handleDeleteEventUploadFlowModalIsOpen(
                      row.uploadFlow.id,
                      row.uploadFlow.name,
                      row.hasExecutions,
                    )
                  }
                />
              </AreaButtonsTableEventFlow>
            ) : (
              <AreaButtonsTableEventFlow>
                <InactiveLinkInfo>
                  {intl.formatMessage({ id: "event.link-flow-status" })}
                </InactiveLinkInfo>

                <ActivateButton
                  disabled={waitingActivating}
                  type="button"
                  onClick={() => {
                    handleActivateEventUploadFlow(row.uploadFlow.id);
                  }}
                >
                  <CiUndo size={18} />
                  {intl.formatMessage({ id: "event_upload_flow.activate" })}
                </ActivateButton>
              </AreaButtonsTableEventFlow>
            )}
          </>
        ),
        right: true,
      },
    ],
    [
      intl,
      handleDeleteEventUploadFlowModalIsOpen,
      handleActivateEventUploadFlow,
      eventId,
      getAllEvents,
    ],
  );

  const editingEventUploadFlow = (id, name) => {
    setManageEventUploadFlowModalIsOpen(true);
    setEditEventUploadFlowId(id);
    setEditEventUploadflowName(name);
  };

  const handleOpenProductsModal = () => {
    setProductsModalVisible(true);
  };

  const handleCloseProductsModal = () => {
    setProductsModalVisible(false);
  };

  const handleSaveProducts = (products) => {
    setSelectedProducts(products);
    setProductsModalVisible(false);
  };

  return (
    <AnimatedMainContainer
      breadcrumb={intl.formatMessage({ id: "edition_information" })}
    >
      <Container>
        <Form
          ref={formRef}
          onSubmit={handleSubmit}
          key={key}
          initialData={{
            event: data.eventEditionName,
            edicaoDaFeira: data.eventEditionCode,
            year: "",
            eventEditionNumber: "",
            place: data.eventVenue,
            pavilion: data.pavilion,
            fair_email: "",
            prefix: data.eventCode,
            video_link: data.linkParaVideos,
            ecommerce_opening_date: data.ecommerce_opening_date,
            ecommerce_opening_time: data.ecommerceOpeningTime,
            ecommerce_closing_date: data.ecommerce_closing_date,
            ecommerce_closing_time: data.ecommerceClosingTime,
            swapcard_group_id: data.swapcardGroupId,
            swapcard_event_id: data.swapcardEventId,
            mounting_start: data.mounting_start,
            mounting_end: data.mounting_end,
            realization_start: data.realization_start,
            realization_end: data.realization_end,
            unmounting_start: data.unmounting_start,
            unmounting_end: data.unmounting_end,
            payments_start: data.payments_start,
            payments_end: data.payments_end,
            payments_limit_end: data.payments_limit_end,
            withdrawal_place: data.withdrawalPlaceList.map((place) => ({
              appointment_name: place?.name,
              appointment_configuration_start: place?.startDate,
              appointment_configuration_end: place?.endDate,
              appointment_configuration_opening: {
                label: timeOptions5m.filter(
                  (i) => i.value === place?.startTime,
                )[0]?.label,
                value: place?.startTime,
              },
              appointment_configuration_closure: {
                label: timeOptions5m.filter(
                  (i) => i.value === place?.endTime,
                )[0]?.label,
                value: place?.endTime,
              },
              appointment_configuration_first_day_opening: {
                label: timeOptions5m.filter(
                  (i) => i.value === place?.firstDayStartTime,
                )[0]?.label,
                value: place?.firstDayStartTime,
              },
              appointment_configuration_first_day_closure: {
                label: timeOptions5m.filter(
                  (i) => i.value === place?.firstDayEndTime,
                )[0]?.label,
                value: place?.firstDayEndTime,
              },
              interval_between_appointments: {
                label: intervalTimes.filter(
                  (i) => i.value === place.answeringTimeInterval,
                )[0]?.label,
                value: place.answeringTimeInterval,
              },
            })),
            credential_metrics_free_quota: data.freeQuotasOnCredentials,
            credential_metrics_considered_area: data.consideredArea,
            status: data.active,
            is_manage_guests_enable: data.manageGuestsEnable,
            is_exhibitors_integration_enable:
              data.integrateExhibitorsOnSwapcard,
            vip_deadline: data?.vip_deadline,
            vip_guest_metrics_parameter: {
              label: vipGuestMetrics.filter(
                (i) => i.value === data.vipGuestMetricsParameter,
              )[0]?.label,
              value: data.vipGuestMetricsParameter,
            },
            vip_guest_metrics_value: data?.vipGuestMetricsValue,
            guestSystemEventId: data.guestSystemEventId,
            guestSystemEventEv: data.guestSystemEventEv,
            guestSystemIntegrationType: {
              label: integrationOptions.filter(
                (i) => i.value === data?.guestSystemIntegrationType,
              )[0]?.label,
              value: data?.guestSystemIntegrationType,
            },
            guestSystemActive: data.guestSystemActive,
          }}
        >
          <TitleContainer>
            <Title>
              <FormattedMessage id="search_for_event_edition" />
            </Title>
            <ActionContainer>
              <BadgeContainer
                onClick={() =>
                  validatePrevPath()
                    ? history.goBack()
                    : history.push("/events", { prevPath: history.location })
                }
              >
                <Badge
                  color="#C9C9C9"
                  text={intl.formatMessage({ id: "goback" })}
                  fontSize="12px"
                />
              </BadgeContainer>
              <BadgeContainer onClick={() => handleSubmitConditional()}>
                <Badge
                  color="#002244"
                  text={intl.formatMessage({ id: "save" })}
                  fontSize="12px"
                  loading={loading}
                />
              </BadgeContainer>
            </ActionContainer>
          </TitleContainer>

          <SessionDivider nr_items="2">
            <Session>
              <SessionContainer>
                <SessionIconContainer>
                  <MdInfo size="16px" color="#002244" />
                </SessionIconContainer>
                <SessionTitle>
                  <FormattedMessage id="informations" />
                </SessionTitle>
              </SessionContainer>
              <FieldsContainer>
                <InputWithLabel
                  name="event"
                  validationBlur={validationBlur}
                  disabled
                  label={intl.formatMessage({ id: "event_edition" })}
                />
                <InformationEditionContainer>
                  <Horizontal>
                    <InputWithLabel
                      name="edicaoDaFeira"
                      validationBlur={validationBlur}
                      disabled
                      className="edition"
                      label={intl.formatMessage({ id: "edition" })}
                    />
                    <InputWithLabel
                      name="year"
                      validationBlur={validationBlur}
                      disabled
                      label={intl.formatMessage({ id: "year" })}
                    />
                    <InputWithLabel
                      name="prefix"
                      validationBlur={validationBlur}
                      disabled
                      label={intl.formatMessage({ id: "prefix" })}
                    />
                    <Toggle
                      label="Status"
                      name="status"
                      onClick={() => handleActivateEvent()}
                    />
                  </Horizontal>
                </InformationEditionContainer>

                <Horizontal>
                  <InputWithLabel
                    name="place"
                    validationBlur={validationBlur}
                    disabled
                    label={intl.formatMessage({ id: "place" })}
                  />

                  <InputWithLabel
                    name="pavilion"
                    validationBlur={validationBlur}
                    disabled
                    label={intl.formatMessage({ id: "pavilion" })}
                    value={data.pavilion}
                  />
                </Horizontal>

                <InputWithLabel
                  name="fair_email"
                  validationBlur={validationBlur}
                  disabled
                  label={intl.formatMessage({ id: "fair_email" })}
                />

                <Horizontal>
                  <InputWithLabel
                    name="video_link"
                    validationBlur={validationBlur}
                    label={intl.formatMessage({ id: "video_link" })}
                  />
                </Horizontal>
              </FieldsContainer>
              <SessionContainer>
                <SessionIconContainer>
                  <FaShoppingBasket size="16px" color="#002244" />
                </SessionIconContainer>
                <SessionTitle>
                  <FormattedMessage id="ecommerce" />
                </SessionTitle>
              </SessionContainer>
              <FieldsContainer>
                <Horizontal>
                  <DatePickerWithLabel
                    name="ecommerce_opening_date"
                    validationBlur={validationBlur}
                    validateEnd={() => validationBlur("ecommerce_closing_date")}
                    label={intl.formatMessage({ id: "opening_date" })}
                    labelOrientation="vertical"
                  />
                  <InputWithLabel
                    name="ecommerce_opening_time"
                    validationBlur={validationBlur}
                    label={intl.formatMessage({ id: "opening_time" })}
                  />
                </Horizontal>
                <Horizontal>
                  <DatePickerWithLabel
                    name="ecommerce_closing_date"
                    validationBlur={validationBlur}
                    label={intl.formatMessage({ id: "closing_date" })}
                    labelOrientation="vertical"
                  />
                  <InputWithLabel
                    name="ecommerce_closing_time"
                    validationBlur={validationBlur}
                    label={intl.formatMessage({ id: "closing_time" })}
                  />
                </Horizontal>
              </FieldsContainer>
              <SessionContainer>
                <SessionIconContainer>
                  <FaInfinity size="16px" color="#002244" />
                </SessionIconContainer>
                <SessionTitle>
                  <FormattedMessage id="digital_platform" />
                </SessionTitle>
              </SessionContainer>
              <FieldsContainer>
                <Horizontal>
                  <InputWithLabel
                    name="swapcard_group_id"
                    validationBlur={validationBlur}
                    label={intl.formatMessage({ id: "swapcard_group_id" })}
                  />
                  <InputWithLabel
                    name="swapcard_event_id"
                    validationBlur={validationBlur}
                    label={intl.formatMessage({ id: "swapcard_event_id" })}
                  />
                </Horizontal>
                <Horizontal>
                  <Toggle
                    label={intl.formatMessage({ id: "integrate_exhibitors" })}
                    name="is_exhibitors_integration_enable"
                    onClick={handleExhibitorsIntegration}
                  />
                </Horizontal>
              </FieldsContainer>
              <SessionContainer>
                <SessionIconContainer>
                  <RiVipDiamondFill size="16px" color="#002244" />
                </SessionIconContainer>
                <SessionTitle>
                  <FormattedMessage id="vip_guests" />
                </SessionTitle>
              </SessionContainer>
              <FieldsContainer>
                <VIPCategoryContainer>
                  <Horizontal>
                    <DatePickerWithLabel
                      name="vip_deadline"
                      validationBlur={validationBlur}
                      label={intl.formatMessage({ id: "vip_deadline" })}
                      labelWidth="100px"
                      disabled={data.vipDeadline}
                      required
                    />
                    <Toggle
                      label={intl.formatMessage({ id: "manage_guests" })}
                      name="is_manage_guests_enable"
                      onClick={() => handleEnableManageGuests()}
                    />
                  </Horizontal>
                </VIPCategoryContainer>

                <VIPCategoryContainer>
                  <SelectWithLabel
                    name="vip_guest_metrics_parameter"
                    validationBlur={validationBlur}
                    label={intl.formatMessage({
                      id: "vip_guest_metrics",
                    })}
                    placeholder={intl.formatMessage({
                      id: "vip_guest_metrics",
                    })}
                    labelOrientation="horizontal"
                    labelWidth="100px"
                    options={vipGuestMetrics}
                    disabled={data.vipGuestMetricsParameter}
                    required
                  />
                  <InputWithHorizontalLabel
                    name="vip_guest_metrics_value"
                    label={intl.formatMessage({
                      id: "quotas",
                    })}
                    labelWidth="100px"
                    validationBlur={validationBlur}
                    disabled={data.vipGuestMetricsValue}
                    required
                  />
                </VIPCategoryContainer>

                <VIPCategoryContainer>
                  <FormButton
                    size="auto"
                    fontSize="12px"
                    type="button"
                    onClick={() => handleExportGuests()}
                  >
                    <FormattedMessage id="export_guests_to_xls" />
                  </FormButton>
                </VIPCategoryContainer>
              </FieldsContainer>
              <SessionContainer>
                <SessionIconContainer>
                  <MdLabel size="18px" color="#002244" />
                </SessionIconContainer>
                <SessionTitle>
                  <FormattedMessage id="exhibitor_guest_system_configuration" />
                </SessionTitle>
              </SessionContainer>
              <FieldsContainer>
                <Horizontal>
                  <InputWithLabel
                    name="guestSystemEventId"
                    validationBlur={validationBlur}
                    label={intl.formatMessage({ id: "event_Id" })}
                    maxLength="50"
                    disabled={!isGuestSystemInformationRequired}
                    required={isGuestSystemInformationRequired}
                  />
                  <InputWithLabel
                    name="guestSystemEventEv"
                    validationBlur={validationBlur}
                    label={intl.formatMessage({ id: "event_EV" })}
                    maxLength="50"
                    disabled={!isGuestSystemInformationRequired}
                    required={isGuestSystemInformationRequired}
                  />
                </Horizontal>
                <Horizontal>
                  <Toggle
                    name="guestSystemActive"
                    label={intl.formatMessage({ id: "active" })}
                    onClick={handleGuestSystemToggleClick}
                  />
                  <SelectWithLabel
                    name="guestSystemIntegrationType"
                    validationBlur={validationBlur}
                    label={intl.formatMessage({
                      id: "integration_type_select",
                    })}
                    placeholder={intl.formatMessage({ id: "integration_type" })}
                    validateEnd={() =>
                      validationBlur("guestSystemIntegrationType")
                    }
                    options={integrationOptions}
                    disabled={!isGuestSystemInformationRequired}
                    required={isGuestSystemInformationRequired}
                  />
                </Horizontal>
              </FieldsContainer>
            </Session>
            <Session>
              <SessionContainer>
                <SessionIconContainer>
                  <MdTimelapse size="16px" color="#002244" />
                </SessionIconContainer>
                <SessionTitle>
                  <FormattedMessage id="periods" />
                </SessionTitle>
              </SessionContainer>
              <FieldsContainer>
                <PeriodCategoryContainer>
                  <PeriodCategoryTitle>
                    <FormattedMessage id="assemble" />
                  </PeriodCategoryTitle>

                  <PeriodCategoryFieldsContainer>
                    <DatePickerWithLabel
                      name="mounting_start"
                      validationBlur={validationBlur}
                      validateEnd={() => validationBlur("mounting_end")}
                      label={intl.formatMessage({ id: "start" })}
                      popperPlacement="bottom-start"
                      labelWidth="unset"
                      maxWidth="200px"
                      required={!isAdvertisingEvent}
                    />
                    <LabelEndContainer>
                      <DatePickerWithLabel
                        name="mounting_end"
                        validationBlur={validationBlur}
                        label={intl.formatMessage({ id: "end" })}
                        labelWidth="unset"
                        popperPlacement="bottom-end"
                        maxWidth="200px"
                        required={!isAdvertisingEvent}
                      />
                    </LabelEndContainer>

                    <BadgeContainer onClick={clearFieldsMointing}>
                      <ClearButtonContainer>
                        <Badge
                          color="#C9C9C9"
                          text={intl.formatMessage({ id: "clear_fields" })}
                          fontSize="12px"
                        />
                      </ClearButtonContainer>
                    </BadgeContainer>
                  </PeriodCategoryFieldsContainer>
                </PeriodCategoryContainer>

                <PeriodCategoryContainer>
                  <PeriodCategoryTitle>
                    <FormattedMessage id="realization" />
                  </PeriodCategoryTitle>
                  <PeriodCategoryFieldsContainer>
                    <DatePickerWithLabel
                      name="realization_start"
                      validationBlur={validationBlur}
                      validateEnd={() => validationBlur("realization_end")}
                      label={intl.formatMessage({ id: "start" })}
                      labelWidth="unset"
                      popperPlacement="bottom-start"
                      maxWidth="200px"
                      required={!isAdvertisingEvent}
                    />
                    <LabelEndContainer>
                      <DatePickerWithLabel
                        name="realization_end"
                        validationBlur={validationBlur}
                        label={intl.formatMessage({ id: "end" })}
                        labelWidth="unset"
                        popperPlacement="bottom-end"
                        maxWidth="200px"
                        required={!isAdvertisingEvent}
                      />
                    </LabelEndContainer>

                    <BadgeContainer onClick={clearFieldsRelization}>
                      <ClearButtonContainer>
                        <Badge
                          color="#C9C9C9"
                          text={intl.formatMessage({ id: "clear_fields" })}
                          fontSize="12px"
                        />
                      </ClearButtonContainer>
                    </BadgeContainer>
                  </PeriodCategoryFieldsContainer>
                </PeriodCategoryContainer>

                <PeriodCategoryContainer>
                  <PeriodCategoryTitle>
                    <FormattedMessage id="disassemble" />
                  </PeriodCategoryTitle>

                  <PeriodCategoryFieldsContainer>
                    <DatePickerWithLabel
                      name="unmounting_start"
                      validationBlur={validationBlur}
                      validateEnd={() => validationBlur("unmounting_end")}
                      label={intl.formatMessage({ id: "start" })}
                      labelWidth="unset"
                      popperPlacement="bottom-start"
                      maxWidth="200px"
                      required={!isAdvertisingEvent}
                    />
                    <LabelEndContainer>
                      <DatePickerWithLabel
                        name="unmounting_end"
                        validationBlur={validationBlur}
                        label={intl.formatMessage({ id: "end" })}
                        labelWidth="unset"
                        popperPlacement="bottom-end"
                        maxWidth="200px"
                        required={!isAdvertisingEvent}
                      />
                    </LabelEndContainer>

                    <BadgeContainer onClick={clearFieldsUnmounting}>
                      <ClearButtonContainer>
                        <Badge
                          color="#C9C9C9"
                          text={intl.formatMessage({ id: "clear_fields" })}
                          fontSize="12px"
                        />
                      </ClearButtonContainer>
                    </BadgeContainer>
                  </PeriodCategoryFieldsContainer>
                </PeriodCategoryContainer>

                <PeriodCategoryContainer>
                  <PeriodCategoryTitle>
                    <FormattedMessage id="payments" />
                  </PeriodCategoryTitle>
                  <PeriodCategoryFieldsContainer>
                    <DatePickerWithLabel
                      name="payments_start"
                      validationBlur={validationBlur}
                      validateEnd={() => validationBlur("payments_end")}
                      label={intl.formatMessage({ id: "start" })}
                      labelWidth="unset"
                      popperPlacement="bottom-start"
                      maxWidth="200px"
                      required={!isAdvertisingEvent}
                    />
                    <LabelEndContainer>
                      <DatePickerWithLabel
                        name="payments_end"
                        validationBlur={validationBlur}
                        label={intl.formatMessage({ id: "end" })}
                        labelWidth="unset"
                        popperPlacement="bottom-end"
                        maxWidth="200px"
                        required={!isAdvertisingEvent}
                      />
                    </LabelEndContainer>
                    <BadgeContainer onClick={clearFieldsPayments}>
                      <ClearButtonContainer>
                        <Badge
                          color="#C9C9C9"
                          text={intl.formatMessage({ id: "clear_fields" })}
                          fontSize="12px"
                        />
                      </ClearButtonContainer>
                    </BadgeContainer>
                  </PeriodCategoryFieldsContainer>
                </PeriodCategoryContainer>

                <PeriodCategoryContainer>
                  <PeriodCategoryTitle>
                    <FormattedMessage id="payments_limit" />
                  </PeriodCategoryTitle>
                  <PeriodCategoryFieldsContainer className="payment_limit">
                    <DatePickerWithLabel
                      name="payments_limit_end"
                      validationBlur={validationBlur}
                      label={intl.formatMessage({ id: "end" })}
                      labelWidth="unset"
                      popperPlacement="bottom-start"
                      maxWidth="200px"
                      required={!isAdvertisingEvent}
                    />

                    <BadgeContainer onClick={clearFieldsPaymentsLimitEnd}>
                      <ClearButtonContainer>
                        <Badge
                          color="#C9C9C9"
                          text={intl.formatMessage({ id: "clear_fields" })}
                          fontSize="12px"
                        />
                      </ClearButtonContainer>
                    </BadgeContainer>
                  </PeriodCategoryFieldsContainer>
                </PeriodCategoryContainer>
              </FieldsContainer>
              <SessionContainer>
                <SessionIconContainer>
                  <MdAssignmentInd size="16px" color="#002244" />
                </SessionIconContainer>
                <SessionTitle>
                  <FormattedMessage id="credentials" />
                </SessionTitle>
              </SessionContainer>
              <FieldsContainer>
                <CredentialsContainer>
                  <CredentialsTitle>
                    <FormattedMessage id="appointment_configuration" />
                  </CredentialsTitle>

                  {data.withdrawalPlaceList.map((item, index) => {
                    return (
                      index < withdrawalPlaceListSize && (
                        <Scope path={`withdrawal_place[${index}]`}>
                          {index > 0 && (
                            <>
                              <WithdrawalPlaceContainer></WithdrawalPlaceContainer>
                            </>
                          )}
                          {index > 0 &&
                            index === withdrawalPlaceListSize - 1 && (
                              <WithdrawalPlaceActionsContainer>
                                <BadgeContainer
                                  onClick={() =>
                                    removeWithdrawalPlaceListItem(index)
                                  }
                                >
                                  <Badge
                                    color="#002244"
                                    text={intl.formatMessage({ id: "remove" })}
                                    fontSize="12px"
                                  />
                                </BadgeContainer>
                              </WithdrawalPlaceActionsContainer>
                            )}
                          <CredentialsFieldsContainer>
                            <InputWithHorizontalLabel
                              name="appointment_name"
                              validationBlur={validationBlur}
                              label={intl.formatMessage({ id: "name" })}
                              labelWidth="80px"
                              required
                            />
                          </CredentialsFieldsContainer>
                          <CredentialsFieldsContainer>
                            <DatePickerWithLabel
                              name="appointment_configuration_start"
                              validationBlur={validationBlur}
                              label={intl.formatMessage({ id: "start" })}
                              labelWidth="80px"
                              popperPlacement="bottom-start"
                              validateEnd={() =>
                                validationBlur(
                                  `withdrawal_place[${index}].appointment_configuration_end`,
                                )
                              }
                              required
                            />
                            <DatePickerWithLabel
                              name="appointment_configuration_end"
                              validationBlur={validationBlur}
                              label={intl.formatMessage({ id: "end" })}
                              test={formRef?.current?.getFieldValue(
                                `withdrawal_place[${index}].appointment_configuration_start`,
                              )}
                              labelWidth="80px"
                              popperPlacement="bottom-end"
                              required
                            />
                          </CredentialsFieldsContainer>
                          <CredentialsFieldsContainer>
                            <SelectWithLabel
                              name="appointment_configuration_opening"
                              validationBlur={validationBlur}
                              label={intl.formatMessage({ id: "opening" })}
                              placeholder={intl.formatMessage({
                                id: "opening",
                              })}
                              validateEnd={() =>
                                validationBlur(
                                  `withdrawal_place[${index}].appointment_configuration_closure`,
                                )
                              }
                              options={timeOptions5m}
                              required
                            />
                            <SelectWithLabel
                              name="appointment_configuration_closure"
                              validationBlur={validationBlur}
                              label={intl.formatMessage({ id: "closure" })}
                              placeholder={intl.formatMessage({
                                id: "closure",
                              })}
                              options={timeOptions5m}
                              required
                            />
                            <SelectWithLabel
                              name="interval_between_appointments"
                              validationBlur={validationBlur}
                              label={intl.formatMessage({
                                id: "interval_between_appointments",
                              })}
                              placeholder={intl.formatMessage({
                                id: "interval_between_appointments",
                              })}
                              rootClass="interval"
                              options={intervalTimes}
                              disabled={item.answeringTimeInterval}
                              required
                            />
                          </CredentialsFieldsContainer>
                          <CredentialsFieldsContainer>
                            <SelectWithLabel
                              name="appointment_configuration_first_day_opening"
                              validationBlur={validationBlur}
                              label={intl.formatMessage({
                                id: "first_day_opening",
                              })}
                              placeholder={intl.formatMessage({
                                id: "first_day_opening",
                              })}
                              validateEnd={() =>
                                validationBlur(
                                  `withdrawal_place[${index}].appointment_configuration_first_day_opening`,
                                )
                              }
                              options={timeOptions5m}
                              required
                            />
                            <SelectWithLabel
                              name="appointment_configuration_first_day_closure"
                              validationBlur={validationBlur}
                              label={intl.formatMessage({
                                id: "first_day_closure",
                              })}
                              placeholder={intl.formatMessage({
                                id: "first_day_closure",
                              })}
                              validateEnd={() =>
                                validationBlur(
                                  `withdrawal_place[${index}].appointment_configuration_first_day_closure`,
                                )
                              }
                              options={timeOptions5m}
                              required
                            />
                          </CredentialsFieldsContainer>
                        </Scope>
                      )
                    );
                  })}

                  {withdrawalPlaceListSize < 3 && (
                    <VIPCategoryContainer>
                      <FormButton
                        size="auto"
                        fontSize="12px"
                        type="button"
                        onClick={() => incrementWithdrawalPlaceListSize()}
                      >
                        <FormattedMessage id="add_place" />
                      </FormButton>
                    </VIPCategoryContainer>
                  )}

                  <CredentialsTitle>
                    <FormattedMessage id="credential_metrics" />
                  </CredentialsTitle>
                  <Horizontal>
                    <InputWithHorizontalLabel
                      name="credential_metrics_free_quota"
                      validationBlur={validationBlur}
                      label={intl.formatMessage({ id: "free_quota" })}
                      labelWidth="80px"
                      disabled={data.freeQuotasOnCredentials}
                      required={!isAdvertisingEvent}
                    />
                    <InputWithHorizontalLabel
                      name="credential_metrics_considered_area"
                      validationBlur={validationBlur}
                      label={intl.formatMessage({ id: "considered_area" })}
                      labelWidth="80px"
                      disabled={data.consideredArea}
                      required={!isAdvertisingEvent}
                    />
                    {data.consideredArea &&
                      hasEditCredentialMetricsPermission && (
                        <EditMetricsButtonContainer
                          onClick={() => handleMetricsModalOpen()}
                          disabled={!data.consideredArea}
                        >
                          <Badge
                            color="#002244"
                            text={intl.formatMessage({ id: "edit" })}
                            fontSize="12px"
                          />
                        </EditMetricsButtonContainer>
                      )}
                  </Horizontal>
                </CredentialsContainer>
              </FieldsContainer>
              <SessionContainer>
                <SessionIconContainer>
                  <MdImage size="16px" color="#002244" />
                </SessionIconContainer>
                <SessionTitle>
                  <FormattedMessage id="fair_logo" />
                </SessionTitle>
              </SessionContainer>
              <FieldsContainer>
                <DocumentsContainer>
                  {logoSrc ? (
                    <DocumentVisualization>
                      <DocumentOpenText>
                        <DocumentOpenImage src={logoSrc} />
                      </DocumentOpenText>
                    </DocumentVisualization>
                  ) : null}
                </DocumentsContainer>
              </FieldsContainer>

              <FieldsContainer>
                <FormButton
                  size="auto"
                  fontSize="12px"
                  type="button"
                  onClick={() => null}
                >
                  <FormattedMessage id="title_homepage_products_services" />
                </FormButton>

                <div
                  style={{
                    display: "flex",
                    gap: "8px",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <div>
                    <Title>
                      <FormattedMessage id="description_select_products" />
                    </Title>
                  </div>

                  <div>
                    <FormButton
                      fontSize="12px"
                      type="button"
                      onClick={handleOpenProductsModal}
                    >
                      <FormattedMessage id="add" />
                    </FormButton>
                  </div>
                </div>
              </FieldsContainer>
            </Session>
          </SessionDivider>
          <Session>
            <SessionContainer>
              <SessionIconContainer>
                <MdDescription size="16px" color="#002244" />
              </SessionIconContainer>
              <SessionTitle>
                <FormattedMessage id="document_management" />
              </SessionTitle>
            </SessionContainer>
            <FileActionsContainer>
              <BadgeContainer onClick={() => handleOpenEventFileModal()}>
                <Badge
                  color="#002244"
                  text={intl.formatMessage({ id: "add" })}
                  fontSize="12px"
                />
              </BadgeContainer>
            </FileActionsContainer>
            <FieldsContainer>
              <TableContainer>
                <Table
                  data={eventFileList}
                  columns={eventFileColumns}
                  hasPagination={false}
                />
              </TableContainer>
              <PDFModal
                setIsOpen={setViewEventFileModalOpen}
                modalIsOpen={viewEventFileModalOpen}
                pdfLocation={viewEventFileLocation}
              />
            </FieldsContainer>
          </Session>
          <Session>
            <SessionContainer>
              <SessionIconContainer>
                <MdDescription size="16px" color="#002244" />
              </SessionIconContainer>
              <SessionTitle>
                <FormattedMessage id="file_upload_flows" />
              </SessionTitle>
            </SessionContainer>
            <FileActionsContainer>
              <BadgeContainer onClick={() => handleOpenEventUploadFlowModal()}>
                <Badge
                  color="#002244"
                  text={intl.formatMessage({ id: "add" })}
                  fontSize="12px"
                  data-test="buttonDocumentUploadEvent"
                />
              </BadgeContainer>
            </FileActionsContainer>
            <FieldsContainer>
              <TableContainer>
                <Table
                  data={eventUploadFlowsList}
                  columns={eventUploadFlowsColumns}
                  hasPagination={false}
                />
              </TableContainer>
            </FieldsContainer>
          </Session>
          <Session>
            <SessionContainer>
              <SessionIconContainer>
                <MdImage size="16px" color="#002244" />
              </SessionIconContainer>
              <SessionTitle>
                <FormattedMessage id="banner" />
              </SessionTitle>
            </SessionContainer>
            <FieldsContainer>
              <DocumentsContainer>
                <DocumentsUploadContainer>
                  <DocumentUpload>
                    <DocumentDragAndDropContainer>
                      {isBannerUnmodified ? (
                        <DocumentVisualization>
                          <DocumentAction>
                            <MdClose
                              color="#e00000"
                              size={20}
                              onClick={() => {
                                setRemoveBannerModalOpen(true);
                              }}
                            />
                          </DocumentAction>
                          <DocumentOpenText>
                            <DocumentOpenImage src={data.banner} />
                          </DocumentOpenText>
                        </DocumentVisualization>
                      ) : (
                        <>
                          <MdCloudUpload size={32} color="#525a5c" />
                          <DocumentDragAndDropText>
                            <Dropzone
                              name="banner"
                              accept="image/*"
                              multiple={false}
                              type="JPG/JPEG/PNG"
                              maxSize={10000000}
                            />
                          </DocumentDragAndDropText>
                        </>
                      )}
                    </DocumentDragAndDropContainer>
                  </DocumentUpload>
                </DocumentsUploadContainer>
              </DocumentsContainer>
            </FieldsContainer>
          </Session>
        </Form>
      </Container>

      <ConfirmationModal
        setIsOpen={setDateModalIsOpen}
        modalIsOpen={dateModalIsOpen}
        confirmationFunction={() => confirmDateModal()}
        description={intl.formatMessage({
          id: "scheduled_credentials_message",
        })}
        confirmationText={intl.formatMessage({ id: "yes" })}
        cancelText={intl.formatMessage({ id: "no" })}
      />

      <ConfirmationModal
        setIsOpen={setActivateModalIsOpen}
        modalIsOpen={activateModalIsOpen}
        confirmationFunction={() => changeEventStatus()}
        cancelationFunction={() => cancelActivation()}
        description={intl.formatMessage({ id: "activate_event_message" })}
        confirmationText={intl.formatMessage({ id: "yes" })}
        cancelText={intl.formatMessage({ id: "no" })}
      />

      <ConfirmationModal
        setIsOpen={setManageGuestsEnableModalIsOpen}
        modalIsOpen={manageGuestsEnableModalIsOpen}
        confirmationFunction={() => changeManageGuestsStatus()}
        cancelationFunction={() => cancelManageGuestsStatusChange()}
        description={intl.formatMessage({ id: "change_manage_guests_status" })}
        confirmationText={intl.formatMessage({ id: "yes" })}
        cancelText={intl.formatMessage({ id: "no" })}
      />

      <ConfirmationModal
        setIsOpen={setDeactivateModalIsOpen}
        modalIsOpen={deactivateModalIsOpen}
        confirmationFunction={() => changeEventStatus()}
        cancelationFunction={() => cancelActivation()}
        description={intl.formatMessage({ id: "deactivate_event_message" })}
        confirmationText={intl.formatMessage({ id: "yes" })}
        cancelText={intl.formatMessage({ id: "no" })}
      />

      <ConfirmationModal
        setIsOpen={setExhibitorsIntegrationModalIsOpen}
        modalIsOpen={exhibitorsIntegrationModalIsOpen}
        confirmationFunction={() => changeExhibitorsIntegrationStatus()}
        cancelationFunction={() => cancelExhibitorsIntegration()}
        description={intl.formatMessage({
          id: "change_exhibitors_integration_status",
        })}
        confirmationText={intl.formatMessage({ id: "yes" })}
        cancelText={intl.formatMessage({ id: "no" })}
      />

      <ConfirmationModal
        setIsOpen={setVipMetricsConfirmationModalOpen}
        modalIsOpen={vipMetricsConfirmationModalOpen}
        confirmationFunction={() => confirmVipMetricsModal()}
        description={intl.formatMessage({ id: "vip_metrics_change_message" })}
        confirmationText={intl.formatMessage({ id: "yes" })}
        cancelText={intl.formatMessage({ id: "no" })}
      />

      <ConfirmationModal
        setIsOpen={setDeleteFileModalIsOpen}
        modalIsOpen={deleteFileModalIsOpen}
        confirmationFunction={() => handleDeleteEventFile()}
        description={intl.formatMessage({ id: "delete_file_message" })}
        confirmationText={intl.formatMessage({ id: "yes" })}
        cancelText={intl.formatMessage({ id: "no" })}
      />

      <ConfirmationModal
        setIsOpen={setRemoveBannerModalOpen}
        modalIsOpen={removeBannerModalOpen}
        confirmationFunction={() => handleRemoveLoadedBanner()}
        description={intl.formatMessage({ id: "delete_file_message" })}
        confirmationText={intl.formatMessage({ id: "yes" })}
        cancelText={intl.formatMessage({ id: "no" })}
      />

      <CustomDeleteModal
        show={deleteEventUploadFlowModalIsOpen}
        intl={intl}
        title={
          !hasExecutions
            ? intl.formatMessage(
                { id: "CONFIRM_DELETE_FLOW" },
                { flowName: eventUploadFlowNameToDelete },
              )
            : intl.formatMessage(
                { id: "CONFIRM_INACTIVATION_FLOW_TITLE" },
                { flowName: eventUploadFlowNameToDelete },
              )
        }
        description={
          !hasExecutions ? (
            intl.formatMessage({
              id: "delete_event_upload_flow_message",
            })
          ) : (
            <MessageInactivationInfo>
              <span>
                {intl.formatMessage({ id: "event.link-flow-description" })}
              </span>
            </MessageInactivationInfo>
          )
        }
        deletingFlow={loading}
        handleClose={() => setDeleteEventUploadFlowModalIsOpen(false)}
        handleConfirm={() => handleDeleteEventUploadFlow()}
        confirmText={"confirm"}
        cancelText={"goback"}
      />

      <EventFileModal
        setIsOpen={setEditEventFileModalIsOpen}
        modalIsOpen={editEventFileModalIsOpen}
        fileId={fileIdToEventFileModal}
        eventEditionCode={id}
        updateCallback={() => handleSearchForEventEditionFiles()}
      />

      <EventUploadFlowModal
        editingId={editEventUploadFlowId}
        editingName={editEventUploadflowName}
        setEditingId={setEditEventUploadFlowId}
        setIsOpen={setManageEventUploadFlowModalIsOpen}
        modalIsOpen={manageEventUploadFlowModalIsOpen}
        eventEditionCode={id}
        updateCallback={() => handleSearchForEventUploadFlows()}
        associatedFlows={eventUploadFlowsList.map((item) => item.uploadFlow.id)}
      />

      <ProductsModal
        visible={productsModalVisible}
        onCancel={handleCloseProductsModal}
        onSave={handleSaveProducts}
        eventEditionCode={id}
        eventId={eventId}
      />

      <Modal
        modalIsOpen={isMetricsModalOpen}
        setIsOpen={setIsMetricsModalOpen}
        modalWidth={"800px"}
      >
        <Form
          ref={metricsFormRef}
          onSubmit={submitMetricsForm}
          initialData={{
            credential_metrics_free_quota_modal: data.freeQuotasOnCredentials,
            credential_metrics_considered_area_modal: data.consideredArea,
          }}
        >
          <CredentialsTitle>
            <FormattedMessage id="credential_metrics" />
          </CredentialsTitle>
          <Horizontal>
            <InputWithHorizontalLabel
              name="credential_metrics_free_quota_modal"
              validationBlur={validationBlurMetrics}
              label={intl.formatMessage({ id: "free_quota" })}
              labelWidth="80px"
              labelOrientation="vertical"
              required
            />
            <InputWithHorizontalLabel
              name="credential_metrics_considered_area_modal"
              validationBlur={validationBlurMetrics}
              label={intl.formatMessage({ id: "considered_area" })}
              labelWidth="80px"
              labelOrientation="vertical"
              required
            />
          </Horizontal>
          <ModalSaveMetricsContainer>
            <Badge
              color="#002244"
              text={intl.formatMessage({ id: "save" })}
              fontSize="12px"
              loading={loading}
              onClick={() => metricsFormRef.current.submitForm()}
            />
          </ModalSaveMetricsContainer>
        </Form>
      </Modal>
    </AnimatedMainContainer>
  );
};

export default Detail;
